import React, {useState, useEffect} from 'react'
import useImage from 'use-image';

// Bootstrap components
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Collapse from 'react-bootstrap/Collapse';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Dropdown from 'react-bootstrap/Dropdown';
import { Carousel, Accordion, Alert } from 'react-bootstrap';

// Pagination for performance
import PaginatedItems from '../shared/AccordionPaginatedItems';

// React Konva components
import { Text, Stage, Layer, Transformer, Rect } from 'react-konva';
import { Image as ImageKonva } from 'react-konva';

// Text component
import { EditableTextInput } from "./EditableTextInput";

// For confirmation dialogs
import {confirm} from 'react-bootstrap-confirmation';

// Custom Icons Bootstrap
import { ChevronRight, ChevronLeft, SquareFill, Palette, TextLeft, TextCenter, TextRight, PlusSquare, DashSquare, Wallet2, Wrench, Fonts, TextareaT, Upload, Book, Front, SymmetryVertical, Trash, Download, XLg, Dice5, PlusCircle, ArrowsCollapse } from 'react-bootstrap-icons';

// Toast
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


// For shared context modules ------
import { useSharedNavigationFunctions } from "../../shared/NavigationFunctions";
import { useSharedNavigationPageGlobalState } from "../../shared/NavigationPageGlobalState";
import { useSharedUIFunctions } from "../../shared/UIFunctions";


// --------------
// MAIN COMPONENT
// --------------

const BackgroundGenerator = (props) => {

    // Capture today's date 
    const current = new Date();
    const date = `${current.getFullYear()}_${current.getMonth()+1}_${current.getDate()}`;
    //console.log("Date=" + date);

    // Debug
    // console.log("props:", props);
    // console.log("props.requireWalletToDisplayAccessoriesItems = " + props.requireWalletToDisplayAccessoriesItems);
    // console.log(" props.isCowOwner=" + props.isCowOwner);

    // Init variable from components props --------------------------------------------------

    // Store the list of available background for this session
    // This will also be augmented through upload   
    const [availableBackground, setAvailableBackground] = useState(props.availableBackground);
    
    // STore custom assets uploaded by the user 
    const [availableAssets, setAvailableAssets] = useState([]);
    
    // Store the list of available accessories 
    const [availableAccessories1] = useState(props.availableAccessories1);
    const [availableAccessories2] = useState(props.availableAccessories2);

    // Slicers for each type of assets that we want to put in a Carousel on the UI
    const [availableCowsSlices, setAvailableCowsSlices] = useState([]);
    const [availablePartner1Slices, setAvailablePartner1Slices] = useState([]);
    const [availablePartner2Slices, setAvailablePartner2Slices] = useState([]);
    const [availableAccessories1Slices, setAvailableAccessories1Slices] = useState([]);
    const [availableAccessories2Slices, setAvailableAccessories2Slices] = useState([]);

    // Collection assets
    // Loaded though a useEffect()
    const [myCows, setMyCows] = useState(props.myAssets);
    const collectionAssetsGenerationFunction = props.collectionAssets;
    const [availableCows, setAvailableCows] = useState(collectionAssetsGenerationFunction());
    const [accordionDefaultActiveKey] = useState("11");       // Key for the UI to display the default pannel

    // Partner assets
    // Made of 0... n array per partner 
    const partner1AssetGenerationFunction = props.partnerAssets[0];
    const partner2AssetGenerationFunction = props.partnerAssets[1];
    const [allPartnerAssets, setAllPartnerAssets] = useState([partner1AssetGenerationFunction(), partner2AssetGenerationFunction()]);
    
    // Panel display status
    const accessories1PannelWalletRequired = props.displayItemConfig.accessories1 === "walletOnly";
    const accessories2PannelWalletRequired = props.displayItemConfig.accessories2 === "walletOnly";
    //const partner1PannelWalletRequired = props.displayItemConfig.partner1 === "walletOnly";
    //const partner2PannelWalletRequired = props.displayItemConfig.partner2 === "walletOnly";
    const canDisplayAccessories1Panel = (props.displayItemConfig.accessories1 !== "never") && (!accessories1PannelWalletRequired || (props.isCowOwner && accessories1PannelWalletRequired));
    const canDisplayAccessories2Panel = (props.displayItemConfig.accessories2 !== "never") && (!accessories2PannelWalletRequired || (props.isCowOwner && accessories2PannelWalletRequired));
    const canDisplayPartner1Panel = props.displayItemConfig.partner1 === "always";
    const canDisplayPartner2Panel = props.displayItemConfig.partner2 === "always";
    // console.log("accessories1PannelWalletRequired=" + accessories1PannelWalletRequired); console.log("accessories2PannelWalletRequired=" + accessories2PannelWalletRequired);
    // console.log("canDisplayAccessories1Panel=" + canDisplayAccessories1Panel); console.log("canDisplayAccessories2Panel=" + canDisplayAccessories2Panel);
    
    
    // Wallet data
    const wallet = props.wallet;
    const walletConnect = props.walletConnect;
    const walletDisconnect = props.walletDisconnect;


    // Page local variables --------------------------------------------------
    
    // Do we have a selected layer on the canva
    const [isSelectedLayerOnCanvas, setIsSelectedLayerOnCanvas] = useState(false);

    // Search query to let the user select which asset he wants 
    const [searchQueryAssetCollection, setSearchQueryAssetCollection] = useState(null);
    const [searchQueryPartner1Collection, setSearchQueryPartner1Collection] = useState(null);
    const [searchQueryPartner2Collection, setSearchQueryPartner2Collection] = useState(null);

    const allowCheckUserWallet = props.allowCheckUserWallet;
    const allowAssetSelection = props.allowAssetSelection;
    const allowAssetReRollConfig = props.allowAssetReRollConfig;
    
    // For about modal
    const [instructionsModalShow, setInstructionsModalShow] = useState(false);
    const handleInstructionsModalClose = () => setInstructionsModalShow(false);
    const handleInstructionsModalShow = () => setInstructionsModalShow(true);



    // Retrieve items from context --------------------------------------------------
    // Mavigation functions
    const { 
        isSelectedCowOnCanvas, setIsSelectedCowOnCanvas,        // TODO: Move somewhere else
    } = useSharedNavigationFunctions();
    // Global nav
    const { 
        // selectedNavItem, 
        // setOwnerAvailableCows,
        // setOwnerAvailableCowsNFT,
        // setHasUserSelectedACow,
        ownerWalletAddress, setOwnerWalletAddress,      // User wallet address to prevent querying user collection multiple time 
        // setOpenseaCollectionData
    } = useSharedNavigationPageGlobalState();
    // UIFunctions functions
    const { 
        GenericBootstrapAccordionToggle
    } = useSharedUIFunctions();
    // Retrieve items from context --------------------------------------------------
    

    // useEffect() declarations -----------------------------------------------------
    // Resize the stage based on screen size
    // Trigger upon page load and when user resize
    useEffect(() => { 
        //let isMounted = true;               // note mutable flag 
        //if (isMounted) {
            fitStageIntoParentContainer();
            window.addEventListener('resize', fitStageIntoParentContainer);
        //}
        return () => {
            //isMounted = false;
            window.removeEventListener('resize', fitStageIntoParentContainer);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Initialize the context 
    // Setup the myCows / availableCows based on ownership 
    useEffect(() => {
        if (props.isCowOwner) {
           // console.log("props.isCowOwner return",props.ownerAvailableCows);
           //setAccordionDefaultActiveKey("10");
           setMyCows(props.myAssets);
        } else {
            setMyCows([]);
            //setAccordionDefaultActiveKey("11");
        }
    }, [props]);

    // Split the list of available collection assets into small chunk
    // So we can display them in an carousel 
    useEffect(() => {
        const rows = availableCows.reduce(function (rows, key, index) { 
            return (index % 8 === 0 ? rows.push([key]) 
              : rows[rows.length-1].push(key)) && rows;
        }, []);
        setAvailableCowsSlices(rows);

        // DEBUG
        // console.log("useEffect() availableCows: ", availableCows);
        // console.log("useEffect() availableCowsSlices: ", availableCowsSlices);

    }, [availableCows]);
    // Split the list of available accessories into small chunk
    // So we can display them in an carousel 
    useEffect(() => {
        //console.log(availableAccessories1);
        if (availableAccessories1 != null) {
            const rows = availableAccessories1.reduce(function (rows, key, index) { 
                return (index % 8 === 0 ? rows.push([key]) 
                : rows[rows.length-1].push(key)) && rows;
            }, []);
            setAvailableAccessories1Slices(rows);
        }
    }, [availableAccessories1]);
    useEffect(() => {
        if (availableAccessories2 != null) {
            const rows = availableAccessories2.reduce(function (rows, key, index) { 
                return (index % 8 === 0 ? rows.push([key]) 
                : rows[rows.length-1].push(key)) && rows;
            }, []);
            setAvailableAccessories2Slices(rows);
        }   
    }, [availableAccessories2]);
    // Split the list of available partners assets into small chunk
    // So we can display them in an carousel 
    useEffect(() => {
        if (allPartnerAssets != null) {
            const rowsPartner1 = allPartnerAssets[0].reduce(function (rows, key, index) { 
                return (index % 8 === 0 ? rows.push([key]) 
                : rows[rows.length-1].push(key)) && rows;
            }, []);
            const rowsPartner2 = allPartnerAssets[1].reduce(function (rows, key, index) { 
                return (index % 8 === 0 ? rows.push([key]) 
                : rows[rows.length-1].push(key)) && rows;
            }, []);
            setAvailablePartner1Slices(rowsPartner1);
            setAvailablePartner2Slices(rowsPartner2);
        } 
    }, [allPartnerAssets])

    // Delayed refresh upon background selection
    const [triggerTimeoutStageRefresh, setTriggerTimeoutStageRefresh] = useState(0);
    useEffect(() => {
        const timer = setTimeout(() => {
            //console.log("Timeout reach. Calling fitStageIntoParentContainer...");
            fitStageIntoParentContainer();
        }, 10);
        return () => clearTimeout(timer);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [triggerTimeoutStageRefresh]);

    // Delayed refresh upon download button click
    const [triggerTimeoutDownloadAssetRefresh, setTriggerTimeoutDownloadAssetRefresh] = useState(0);
    useEffect(() => {
        const timer = setTimeout(() => {
            if (triggerTimeoutDownloadAssetRefresh >0 ) {
                const uri = stageRef.current.toDataURL({ pixelRatio: 3 });
                //console.log("Exporting image:" + uri);
                downloadURI(uri, props.labelsConfig.collectionShortName + '_Banner_' + date + '.png');
            }
        }, 500);
        return () => clearTimeout(timer);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [triggerTimeoutDownloadAssetRefresh, date]);
    // useEffect() declarations -----------------------------------------------------
    


    


    // Local Functions --------------------------------------------------
    
    // Function that return either all or portion of 
    // available background for the editor 
    const getAvailableBackground = (index) => {
        if (index !== null) {
            return availableBackground[index];
        } else {
            return availableBackground;
        }
    }

    // Function that add a new cow to the existing selection
    // The cow to be added is entered by the user
    // We check that the cow is a valid number that exists
    const performSearchQueryAssetCollection = () => {

        //console.log("searchQueryAssetCollection=", searchQueryAssetCollection);
        if (searchQueryAssetCollection === null) {
            console.error("No search query provided");
        } else {
            if (props.assetSearchFunction !== null) {

                const assetQueryString = searchQueryAssetCollection;
                //console.log("in function with customCow=" + cowId);

                // Custom function that perform search for the collection
                const result = props.assetSearchFunction(assetQueryString, props.assetCollectionMetadata, "collection");
                if (result !== null) { 
                    let updatedArray = [];
                    // Start with the results
                    for (var i = 0; i<result.length; i++) {
                        updatedArray.push(result[i]);
                    }
                    // // Add the previous results (if space is left)
                    // for (var i = 0; i<(availableCows.length-result.length); i++) {
                    //     updatedArray.push(availableCows[i]);
                    // }
                    setAvailableCows(updatedArray);

                } else {
                    console.log("No match for assetQueryString=" + assetQueryString );
                }

            } else {
                console.error("Need to implement custom function to search asset for this collection!");
            }
        }
        
    }

    // Method that intercept input value change
    // This is use for letting the user changing the cow
    const updateInputValueForCollectionSelector = (evt) => {
        //console.log("We are updating input value to:" + val);
        const val = evt.target.value;
        setSearchQueryAssetCollection(val);
    }


    // Function that perform a new cow to the existing selection
    // The cow to be added is entered by the user
    // We check that the cow is a valid number that exists
    const performSearchQueryPartner1Collection = () => {

        //console.log("customCowNumberToAddToCollection=", customCowNumberToAddToCollection);
        if (searchQueryPartner1Collection === null) {
            console.error("No search query provided");
        } else {
            if (props.assetSearchFunction !== null) {

                const assetQueryString = searchQueryPartner1Collection;
                //console.log("in function with customCow=" + cowId);

                // Custom function that perform search for the collection
                const result = props.assetSearchFunction(assetQueryString, props.partner1CollectionMetadata, "partner1");
                if (result !== null) { 
                    let updatedArray = [];
                    // Start with the results
                    for (var i = 0; i<result.length; i++) {
                        updatedArray.push(result[i]);
                    }
                    // // Add the previous results (if space is left)
                    // for (var i = 0; i<(availableCows.length-result.length); i++) {
                    //     updatedArray.push(availableCows[i]);
                    // }
                    setAllPartnerAssets([updatedArray, partner2AssetGenerationFunction()]);

                } else {
                    console.log("No match for assetQueryString=" + assetQueryString );
                }

            } else {
                console.error("Need to implement custom function to search asset for this partner 1 collection!");
            }
        }
        
    }

    // Method that intercept input value change
    // This is use for letting the user changing the cow
    const updateInputValueForPartner1Selector = (evt) => {
        //console.log("We are updating input value to:" + val);
        const val = evt.target.value;
        setSearchQueryPartner1Collection(val);
    }

    // Function that perform a new cow to the existing selection
    // The cow to be added is entered by the user
    // We check that the cow is a valid number that exists
    const performSearchQueryPartner2Collection = () => {

        //console.log("customCowNumberToAddToCollection=", customCowNumberToAddToCollection);
        if (searchQueryPartner2Collection === null) {
            console.error("No search query provided");
        } else {
            if (props.assetSearchFunction !== null) {

                const assetQueryString = searchQueryPartner2Collection;
                //console.log("in function with customCow=" + cowId);

                // Custom function that perform search for the collection
                const result = props.assetSearchFunction(assetQueryString, props.partner2CollectionMetadata, "partner2");
                if (result !== null) { 
                    let updatedArray = [];
                    // Start with the results
                    for (var i = 0; i<result.length; i++) {
                        updatedArray.push(result[i]);
                    }
                    // // Add the previous results (if space is left)
                    // for (var i = 0; i<(availableCows.length-result.length); i++) {
                    //     updatedArray.push(availableCows[i]);
                    // }
                    setAllPartnerAssets([partner1AssetGenerationFunction(), updatedArray]);

                } else {
                    console.log("No match for assetQueryString=" + assetQueryString );
                }

            } else {
                console.error("Need to implement custom function to search asset for this partner 2 collection!");
            }
        }
        
    }

    // Method that intercept input value change
    // This is use for letting the user changing the cow
    const updateInputValueForPartner2Selector = (evt) => {
        //console.log("We are updating input value to:" + val);
        const val = evt.target.value;
        setSearchQueryPartner2Collection(val);
    }





    // -------------------
    // EXTERNAL COMPONENTS
    // -------------------

    const WalletConnectionButtons = (props) => {

        const isMiniMode = props.isMiniMode;

        let metaMaskLabel = null;
        let coinbaseLabel = null;
        let walletConnectLabel = null;
        
        if (isMiniMode) {
            metaMaskLabel = "";
            coinbaseLabel = "";
            walletConnectLabel = "";
        } else {
            metaMaskLabel = "Metamask";
            coinbaseLabel = "Coinbase";
            walletConnectLabel = "WalletConnect";
        }

        return (

            <>
            <button title="Connect with your Metamask" onClick={() => walletConnect('injected')}
                className="mx-1 mt-1 mb-1"
                style={{
                        backgroundImage: `url("data:image/svg+xml;base64,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")`, 
                        backgroundColor: 'white',
                        backgroundRepeat: 'no-repeat', 
                        borderRadius: '7px',
                        border: '1px black solid', 
                        fontSize: '1em' 
                    }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {metaMaskLabel}       
            </button> 
            <button title="Connect with your Coinbase Wallet" onClick={() => walletConnect('walletlink')}
                className="mx-1 mt-1 mb-1"
                style={{
                        backgroundImage: `url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI4IiBoZWlnaHQ9IjI4IiBmaWxsPSIjMkM1RkY2Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQgMjMuOEMxOS40MTI0IDIzLjggMjMuOCAxOS40MTI0IDIzLjggMTRDMjMuOCA4LjU4NzYxIDE5LjQxMjQgNC4yIDE0IDQuMkM4LjU4NzYxIDQuMiA0LjIgOC41ODc2MSA0LjIgMTRDNC4yIDE5LjQxMjQgOC41ODc2MSAyMy44IDE0IDIzLjhaTTExLjU1IDEwLjhDMTEuMTM1OCAxMC44IDEwLjggMTEuMTM1OCAxMC44IDExLjU1VjE2LjQ1QzEwLjggMTYuODY0MiAxMS4xMzU4IDE3LjIgMTEuNTUgMTcuMkgxNi40NUMxNi44NjQyIDE3LjIgMTcuMiAxNi44NjQyIDE3LjIgMTYuNDVWMTEuNTVDMTcuMiAxMS4xMzU4IDE2Ljg2NDIgMTAuOCAxNi40NSAxMC44SDExLjU1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==")`, 
                        backgroundColor: 'white',
                        backgroundRepeat: 'no-repeat', 
                        borderRadius: '7px',
                        border: '1px black solid', 
                        fontSize: '1em',
                    }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {coinbaseLabel}
                
            </button> 
            <button title="Connect with your WalletConnect" onClick={() => walletConnect('walletconnect')}
                className="mx-1 mt-1 mb-1"
                style={{
                        backgroundImage: `url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI4IiBoZWlnaHQ9IjI4IiBmaWxsPSIjM0I5OUZDIi8+CjxwYXRoIGQ9Ik04LjM4OTY5IDEwLjM3MzlDMTEuNDg4MiA3LjI3NTM4IDE2LjUxMTggNy4yNzUzOCAxOS42MTAzIDEwLjM3MzlMMTkuOTgzMiAxMC43NDY4QzIwLjEzODIgMTAuOTAxNyAyMC4xMzgyIDExLjE1MjkgMTkuOTgzMiAxMS4zMDc4TDE4LjcwNzYgMTIuNTgzNUMxOC42MzAxIDEyLjY2MDkgMTguNTA0NSAxMi42NjA5IDE4LjQyNzEgMTIuNTgzNUwxNy45MTM5IDEyLjA3MDNDMTUuNzUyMyA5LjkwODcgMTIuMjQ3NyA5LjkwODcgMTAuMDg2MSAxMi4wNzAzTDkuNTM2NTUgMTIuNjE5OEM5LjQ1OTA5IDEyLjY5NzMgOS4zMzM1IDEyLjY5NzMgOS4yNTYwNCAxMi42MTk4TDcuOTgwMzkgMTEuMzQ0MkM3LjgyNTQ3IDExLjE4OTMgNy44MjU0NyAxMC45MzgxIDcuOTgwMzkgMTAuNzgzMkw4LjM4OTY5IDEwLjM3MzlaTTIyLjI0ODUgMTMuMDEyTDIzLjM4MzggMTQuMTQ3NEMyMy41Mzg3IDE0LjMwMjMgMjMuNTM4NyAxNC41NTM1IDIzLjM4MzggMTQuNzA4NEwxOC4yNjQ1IDE5LjgyNzdDMTguMTA5NiAxOS45ODI3IDE3Ljg1ODQgMTkuOTgyNyAxNy43MDM1IDE5LjgyNzdDMTcuNzAzNSAxOS44Mjc3IDE3LjcwMzUgMTkuODI3NyAxNy43MDM1IDE5LjgyNzdMMTQuMDcwMiAxNi4xOTQ0QzE0LjAzMTQgMTYuMTU1NyAxMy45Njg2IDE2LjE1NTcgMTMuOTI5OSAxNi4xOTQ0QzEzLjkyOTkgMTYuMTk0NCAxMy45Mjk5IDE2LjE5NDQgMTMuOTI5OSAxNi4xOTQ0TDEwLjI5NjYgMTkuODI3N0MxMC4xNDE3IDE5Ljk4MjcgOS44OTA1MyAxOS45ODI3IDkuNzM1NjEgMTkuODI3OEM5LjczNTYgMTkuODI3OCA5LjczNTYgMTkuODI3NyA5LjczNTYgMTkuODI3N0w0LjYxNjE5IDE0LjcwODNDNC40NjEyNyAxNC41NTM0IDQuNDYxMjcgMTQuMzAyMiA0LjYxNjE5IDE0LjE0NzNMNS43NTE1MiAxMy4wMTJDNS45MDY0NSAxMi44NTcgNi4xNTc2MyAxMi44NTcgNi4zMTI1NSAxMy4wMTJMOS45NDU5NSAxNi42NDU0QzkuOTg0NjggMTYuNjg0MSAxMC4wNDc1IDE2LjY4NDEgMTAuMDg2MiAxNi42NDU0QzEwLjA4NjIgMTYuNjQ1NCAxMC4wODYyIDE2LjY0NTQgMTAuMDg2MiAxNi42NDU0TDEzLjcxOTQgMTMuMDEyQzEzLjg3NDMgMTIuODU3IDE0LjEyNTUgMTIuODU3IDE0LjI4MDUgMTMuMDEyQzE0LjI4MDUgMTMuMDEyIDE0LjI4MDUgMTMuMDEyIDE0LjI4MDUgMTMuMDEyTDE3LjkxMzkgMTYuNjQ1NEMxNy45NTI2IDE2LjY4NDEgMTguMDE1NCAxNi42ODQxIDE4LjA1NDEgMTYuNjQ1NEwyMS42ODc0IDEzLjAxMkMyMS44NDI0IDEyLjg1NzEgMjIuMDkzNiAxMi44NTcxIDIyLjI0ODUgMTMuMDEyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==")`, 
                        backgroundColor: 'white',
                        backgroundRepeat: 'no-repeat', 
                        borderRadius: '7px',
                        border: '1px black solid', 
                        fontSize: '1em'  
                    }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {walletConnectLabel} 
            </button> 
            </>

        )

    };

    // Create a draggable image component 
    // That can also be rotated and resized 
    // Source: https://konvajs.org/docs/react/Transformer.html
    const DraggableAndResizableImage = ({ 
        shapeProps, 
        mode, 
        isSelected, 
        onSelect, 
        onChange, 
        image }) => {
        const [img] = useImage(image.src, 'Anonymous');

        // DEBUG
        // console.log("shapeProps DUMP...");
        //console.log(shapeProps);
        //console.log("mode=" + mode);

        const shapeRef = React.useRef(null);
        const trRef = React.useRef(null);

        // we need to attach transformer manually
        // when we select the shape 
        React.useEffect(() => {
            if (isSelected) {
                // Attaching the transformer here 
                trRef.current.nodes([shapeRef.current]);
                trRef.current.getLayer().batchDraw();
            }
        }, [isSelected]);

        let draggableStatus = null;
        if (mode === "BACKGROUND_LAYER") {
            draggableStatus = false;
        }
        if (mode === "COW_LAYER") {
            draggableStatus=true;
        }
        if (mode === "TEXT_LAYER") {
            draggableStatus=true;
        }

        return (
        <React.Fragment>

            <ImageKonva

                onClick={onSelect}
                onTap={onSelect}
                ref={shapeRef}
                key={"DraggableAndResizableImage_" + shapeProps.mykey}
                {...shapeProps}

                image={img}
                x={image.x}
                y={image.y}
                width={image.width}
                height={image.height}
                offsetX={image.width / 2}
                offsetY={image.height / 2}
                scaleX={image.scaleX}
                scaleY={image.scaleY}

                draggable={draggableStatus}
                onDragEnd={e => {
                    onChange({
                        ...shapeProps,
                        x: e.target.x(),
                        y: e.target.y(),
                    });
                    // state.isDragging = true;
                    // state.x = e.target.x();
                    // state.y = e.target.y();

                }} 
                onTransformEnd={(e) => {
                    // transformer is changing scale of the node
                    // and NOT its width or height
                    // but in the store we have only width and height
                    // to match the data better we will reset scale on transform end
                    const node = shapeRef.current;
                    const scaleX = Math.abs(node.scaleX());
                    const scaleY = Math.abs(node.scaleY());

                    // we will reset it back
                    // actually this looks like a bug
                    // so not enabling this
                    node.scaleX(1);
                    node.scaleY(1);

                    //console.log(shapeRef);
                    // console.log(node);
                    // console.log("scaleX: " + scaleX + "scaleY: " + scaleY);
                    // console.log("X: " + node.x() + "Y: " + node.y());
                    
                    // For some reason, if we've flipped the cow
                    // We need to add 180 degress to the rotation 
                    // to prevent the image to rotate (or flip on the Y axis)
                    // TODO: Investigate why this is an issue in the first place
                    let rotation = node.rotation();
                    if (node.attrs.flipped === true) {
                        rotation = (180 + node.rotation());
                    }
                    
                    onChange({
                        // Adding / removing attributes here 
                        // will not take affect until you update the method
                        // reference by onChange here
                        ...shapeProps,
                        x: node.x(),
                        y: node.y(),
                        // set minimal value
                        width: Math.max(5, node.width() * scaleX),
                        height: Math.max(node.height() * scaleY),
                        rotation: rotation,
                    });
                }}
                // onContextMenu={handleContextMenu}

            />

            {isSelected && (mode === "COW_LAYER") && (
                <Transformer
                    ref={trRef}
                    flipEnabled={false}
                    keepRatio={true}
                    anchorFill="pink"
                    borderStroke="pink"
                    borderStrokeWidth={4}
                    rotateAnchorOffset={30}
                    anchorSize={13}
                    anchorStroke="black"
                    borderDash={[3, 3]}
                    rotationSnaps = {[0, 90, 180, 270]}
                    enabledAnchors={['top-left', 'top-right', 'bottom-left', 'bottom-right']}        // Prevent changing ratio
                    boundBoxFunc={(oldBox, newBox) => {
                        // limit resize
                        if (newBox.width < 5 || newBox.height < 5) {
                        return oldBox;
                        }
                        return newBox;
                    }} 
            />)}

            {/* Experimental support for Right click
            Source: https://codesandbox.io/s/km0n1x8367?file=/src/index.js:1139-1182 */}
            {/* {isSelected && (mode === "COW_LAYER") && selectedShapeContextMenu && (
                <Portal>
                    <ContextMenuShape
                        {...selectedShapeContextMenu}
                        onOptionSelected={handleOptionSelected}
                    />
                </Portal>
            )} */}

            {isSelected && (mode === "BACKGROUND_LAYER") && (
                <Transformer
                    ref={trRef}
                    flipEnabled={false}
                    resizeEnabled={false}
                    rotateEnabled={false}
                    anchorFill="red"
                    borderStroke="red"
                    borderStrokeWidth={2}
                    anchorSize={13}
                    borderDash={[8]}
                    boundBoxFunc={(oldBox, newBox) => {
                        // limit resize
                        if (newBox.width < 5 || newBox.height < 5) {
                            return oldBox;
                        }
                        return newBox;
                    }} 
            />)}

        </React.Fragment>
        );
        
    };


    // Create a EditableText
    const EditableText = ({ 
        shapeProps, 
        isSelected, 
        isEditing,
        onSelect, 
        onChange, 
        onTextChange,
        textObject, 
        onEditing,
        // onSelecting
    }) => {

        // Return and Escape key
        // Will exit the text editor - editor mode
        const RETURN_KEY = 13;
        const ESCAPE_KEY = 27;

        const shapeRef = React.useRef(null);
        const trRef = React.useRef(null);

        //console.log("EditableText - DUMP layer:", textObject);

        // we need to attach transformer manually
        // when we select the shape 
        React.useEffect(() => {
            if (isSelected) {
                // Attaching the transformer here 
                trRef.current.nodes([shapeRef.current]);
                trRef.current.getLayer().batchDraw();
            }
        }, [isSelected]);

        React.useEffect(() => {
            if (!isEditing) {
                // We create a copy of the next being edited
                //console.log("Starting editing text... taking a copy of text: " + textObject.text);
                setIsLocalTextBeingEdited(textObject.text);
            }
        }, [isEditing]);

        let draggableStatus = true;

        //const [isEditing, setIsEditing] = useState(false);
        const [isLocalTextBeingEdited, setIsLocalTextBeingEdited] = useState(textObject.text);

        // Called when we exit editing 
        function onToggleEdit() {
            // console.log("OnTogglEdit isEditing is:" + isEditing);
            // if (!isEditing) {
            //     // We create a copy of the next being edited
            //     //console.log("Starting editing text... taking a copy of text: " + textObject.text);
            //     setIsLocalTextBeingEdited(textObject.text);
            // }
            // setIsEditing(!isEditing);
            onEditing(!isEditing);
            //onTextClick(!isEditing);
        }

        function onLocalTextChange(updatedText) {
            setIsLocalTextBeingEdited(updatedText);
        }

        //console.log("isEditing: " + isEditing);

        // Showing the editor 
        if (isEditing) {
            return (
              <EditableTextInput
                shapeProps={shapeProps}
                x={textObject.x}
                y={textObject.y}
                width={textObject.width}
                height={textObject.height}
                value={isLocalTextBeingEdited}
                onChange={(e) => {
                    //console.log("EditingText... onChange=", e.currentTarget);
                    onLocalTextChange(e.currentTarget.textContent);
                }}
                onKeyDown={(e) => {
                    //console.log("onKeyDown - RETURNKEY = " + RETURN_KEY + " ESCAPE_KEY=" + ESCAPE_KEY + " eKeycode=", e.keyCode);
                    if ((e.keyCode === RETURN_KEY && !e.shiftKey) || e.keyCode === ESCAPE_KEY) {
                        //console.log("onKeyDown - Done editing");
                        onTextChange(e.currentTarget.textContent);
                        onToggleEdit(e);
                    } else {
                        //console.log("onKeyDown - Still updating text")
                    }
                }}
                fontSize={textObject.fontSize} 
                fontWeight={textObject.fontWeight}
                fontFamily={textObject.fontFamily}
                textAlign={textObject.textAlign}
                textColor={textObject.textColor}
              />
            );
          }


        // FOR TEXT DISPLAY - DRAG - ROTATE ONLY - NOT EDITING

        return (
        <React.Fragment>

            {/* <Rect
                x={textObject.x-textObject.width/2-10}
                y={textObject.y-textObject.height/2-10}
                width={textObject.width + 20}
                height={textObject.height + 20}
                //fill={"black"}    // To debug
                perfectDrawEnabled={false}
                onClick={onSelect}
                onTap={onSelect}
            /> */}
            <Text

                // onDblClick={() => {
                //     //console.log("Double clicking!");
                //     setIsEditing(!isEditing);
                //     //onTextClick(!isEditing);
                //   }}
                // onDblTap={() => {
                //     //console.log("Double tapping!");
                //     setIsEditing(!isEditing);
                //     //onTextClick(!isEditing);
                // }}

                onClick={onSelect}
                onTap={onSelect}

                ref={shapeRef}
                key={"TextEditable_" + shapeProps.mykey}
                {...shapeProps}

                text={textObject.text}
                fontSize={textObject.fontSize}
                fontStyle={textObject.fontWeight}
                fontFamily={textObject.fontFamily}
                align={textObject.textAlign}
                verticalAlign="middle"
                fill={textObject.textColor}

                x={textObject.x}
                y={textObject.y}
                width={textObject.width}
                height={textObject.height}
                offsetX={textObject.width / 2}
                offsetY={textObject.height / 2}
                scaleX={textObject.scaleX}

                draggable={draggableStatus}
                onDragEnd={e => {

                    // console.log("onTransformEnd...");

                    onChange({
                        ...shapeProps,
                        x: e.target.x(),
                        y: e.target.y(),
                    });
                    // state.isDragging = true;
                    // state.x = e.target.x();
                    // state.y = e.target.y();

                }} 
                onTransformEnd={(e) => {

                    //console.log("onTransformEnd...");

                    // transformer is changing scale of the node
                    // and NOT its width or height
                    // but in the store we have only width and height
                    // to match the data better we will reset scale on transform end
                    const node = shapeRef.current;
                    const scaleX = Math.abs(node.scaleX());
                    const scaleY = Math.abs(node.scaleY());

                    // we will reset it back
                    // actually this looks like a bug
                    // so not enabling this
                    node.scaleX(1);
                    node.scaleY(1);

                    //console.log(shapeRef);
                    // console.log(node);
                    // console.log("scaleX: " + scaleX + "scaleY: " + scaleY);
                    // console.log("X: " + node.x() + "Y: " + node.y());
                    
                    // For some reason, if we've flipped the cow
                    // We need to add 180 degress to the rotation 
                    // to prevent the image to rotate (or flip on the Y axis)
                    // TODO: Investigate why this is an issue in the first place
                    let rotation = node.rotation();
                    if (node.attrs.flipped === true) {
                        rotation = (180 + node.rotation());
                    }

                    //console.log("node: ", node);
                    
                    const scalledFontSize = node.attrs.fontSize * scaleX;
                    //console.log("scalledFontSize: " + scalledFontSize + " before fontSize: " + node.attrs.fontSize);
                    
                    onChange({
                        // Adding / removing attributes here 
                        // will not take affect until you update the method
                        // reference by onChange here
                        ...shapeProps,
                        x: node.x(),
                        y: node.y(),
                        // set minimal value
                        width: Math.max(5, node.width() * scaleX),
                        height: Math.max(node.height() * scaleY),
                        rotation: rotation,
                        fontSize: scalledFontSize,
                        fontWeight: node.attrs.fontWeight,
                        fontFamily: node.attrs.fontFamily
                    });
                }}
                // onContextMenu={handleContextMenu}

            />

            {isSelected && (
                <Transformer
                    ref={trRef}
                    flipEnabled={false}
                    keepRatio={true}
                    anchorFill="yellow"
                    borderStroke="yellow"
                    borderStrokeWidth={4}
                    rotateAnchorOffset={30}
                    anchorSize={13}
                    anchorStroke="black"
                    borderDash={[3, 3]}
                    rotationSnaps = {[0, 90, 180, 270]}
                    //enabledAnchors={['top-left', 'top-right', 'bottom-left', 'bottom-right']}        // Prevent changing ratio
                    boundBoxFunc={(oldBox, newBox) => {
                        // limit resize
                        if (newBox.width < 5 || newBox.height < 5) {
                        return oldBox;
                        }
                        return newBox;
                    }} 
            />)}

        </React.Fragment>
        );
        
    };

    // Create a Background Image for the Stage
    // This can be both a selected or a non selectable background
    // Background can be made of multiple layer
    // The first layer will take the entire space of the background and can't be selectable
    // All layer above that first layer, if they exist are selectable
    // We do this so that the user to position asset above/below such background elements 
    const BackgroundImage = (props) => {
        // console.log("Loading image... ");
        //console.log("BackgroundImage props: ", props);
        const [image] = useImage(props.image.src, "Image" + props.key);
        
        const shapeRef = React.useRef();
        const trRef = React.useRef();
        const isSelected = props.isSelected;

        // we need to attach transformer manually
        // if selected
        React.useEffect(() => {
            if (isSelected) {
                trRef.current.nodes([shapeRef.current]);
                trRef.current.getLayer().batchDraw();
            }
        }, [isSelected]);

        // Are we on a layer put on top of the background image?
        if (props.selectable) {

            // console.log("layerElement = ");
            // console.log(image);
            // console.log("isSelected = " + props.isSelected);

            return <React.Fragment key={"Fragment_" + props.mykey}>
                <ImageKonva 

                onClick={props.onSelect}
                onTap={props.onSelect}
                ref={shapeRef}
                 
                key={props.mykey}
                // {...props}

                name={props.index}
                image={image} 
                height={props.height} 
                width={props.width} 
                x={props.x} 
                y={props.y}
            />

            <Transformer
                key={"Transformer_" + props.mykey}
                resizeEnabled={false}
                rotationEnabled={false}
                ref={trRef}
                anchorFill="blue"
                borderStroke="blue"
                enabledAnchors={[]}
                anchorSize={10}
                borderDash={[3, 3]}
                boundBoxFunc={(oldBox, newBox) => {
                    // limit resize
                    if (newBox.width < 5 || newBox.height < 5) {
                    return oldBox;
                    }
                    return newBox;
                }}
                
            />

            </React.Fragment>

        } else {

            // Are we on a background of type "template"?
            if (props.mode === "BACKGROUND_TEMPLATE") {

                return <Rect

                fill={props.image.backgroundColor}
                ref={shapeRef}
                key={props.mykey}

                x={props.x}
                y={props.y}
                width={props.width}
                height={props.height}
                // offsetX={image.width / 2}
                // offsetY={image.height / 2}
                // scaleX={image.scaleX}
                // draggable={draggableStatus}

                />
            } else {

                // Are we on a background of type "image/classic"?
                return <ImageKonva 

                    // Detect image size 
                    // onLoad={onImgLoad}
                    // onTransform={handleTransform}

                    onClick={props.onSelect}
                    onTap={props.onSelect}
                    key={props.mykey}
                    ref={shapeRef}
                    image={image} 
                    height={props.height} 
                    width={props.width} 
                    x={props.x} 
                    y={props.y} 
                    // onClick ={(e) => {
                    //     // If we click on the background, 
                    //     // we deselect any cow
                    //     handleUnselectCow();
                    // }}
                />;

            }
        }
    };





    // LOAD DATA FOR EDITORS
    // *********************

    // Load list of background available to the user
    // const editorBackgroudList = getAvailableBackground(null);
    const [editorBackgroudList, setEditorBackgroudList] = useState(getAvailableBackground(null));

    // Load background Items
    const [selectedBackgroundId, setSelectedBackgroundId] = useState(0);        // Store currently selected background
    
    // For editor
    const dragUrl = React.useRef();
    const dragUrlId = React.useRef();
    const dragUrlHeight = React.useRef();
    const dragUrlWidth = React.useRef();
    
    const stageRef = React.useRef();
    const [nbAssetsOnCanvas, setNbAssetsOnCanvas] = useState(0);;
    
    // Handle transfor to resize images
    const [selectedShapeId, setSelectedShapeId] = React.useState(null);           // Which asset is selected?
    
    // Deselect all selected shapes 
    const checkDeselect = (e) => {
        handleUnselectCow();
    };





    // TEXT EDITOR CONTROLS
    // ********************

    const [isTextBeingEditedOnCanvas, setIsTextBeingEditedOnCanvas] = useState(false);
    const [isTextBeingSelectedOnCanvas, setIsTextBeingSelectedOnCanvas] = useState(false);

    // Turn on editing mode for the canvas
    const editSelectedTextToCanvas = () => {
        setIsTextBeingEditedOnCanvas(true);
    }

    // Change textAlign property of selected text 
    const alignText = (direction) => {

        // Fetch selectedElement
        const selectedElement = selectedShapeId;
        // Lookup the index value in the array
        // We don't do a simple array[index] since the index
        // value might not follow the array order once we start 
        // moving element up and down the layers 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        let layerItem = updateLayersArray.find(i => i.index === selectedElement);
        const layerItemIndex = updateLayersArray.indexOf(layerItem);

        // Check that we have selected a text elelement and not a background element
        if (canvasLayersOrdered.layers[0][layerItemIndex].mode === "TEXT_LAYER") {
            //console.log("alignText: found text element ", updateLayersArray[layerItemIndex]);
            updateLayersArray[layerItemIndex].textAlign = direction;
            const updatedCanvasLayersOrdered = {
                layers: [updateLayersArray]
            }
            setCanvasLayersOrdered(updatedCanvasLayersOrdered);
            
        } else {
            //console.log("We have not selected a text element!");
        }

    }

    /**
     * Update the font of the select text by a given increment (positive or negative)
     * @param {*} fontSizeIncrement the increment to add to the existing fontSize
     */
    const updateFontSize = (fontSizeIncrement) => {

        // Fetch selectedElement
        const selectedElement = selectedShapeId;

        // Lookup the index value in the array
        // We don't do a simple array[index] since the index
        // value might not follow the array order once we start 
        // moving element up and down the layers 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        let layerItem = updateLayersArray.find(i => i.index === selectedElement);
        const layerItemIndex = updateLayersArray.indexOf(layerItem);

        // Check that we have selected a text elelement and not a background element
        if (canvasLayersOrdered.layers[0][layerItemIndex].mode === "TEXT_LAYER") {
            //console.log("alignText: found text element ", updateLayersArray[layerItemIndex]);
            const currentSize = updateLayersArray[layerItemIndex].fontSize
            updateLayersArray[layerItemIndex].fontSize = currentSize + (currentSize * fontSizeIncrement);
            const updatedCanvasLayersOrdered = {
                layers: [updateLayersArray]
            }
            setCanvasLayersOrdered(updatedCanvasLayersOrdered);
            
        } else {
            //console.log("We have not selected a text element!");
        }

    }

    // Change textColor property of selected text 
    const updateTextColor = (color) => {

        // Fetch selectedElement
        const selectedElement = selectedShapeId;
        // Lookup the index value in the array
        // We don't do a simple array[index] since the index
        // value might not follow the array order once we start 
        // moving element up and down the layers 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        let layerItem = updateLayersArray.find(i => i.index === selectedElement);
        const layerItemIndex = updateLayersArray.indexOf(layerItem);

        // Check that we have selected a text elelement and not a background element
        if (canvasLayersOrdered.layers[0][layerItemIndex].mode === "TEXT_LAYER") {
            //console.log("alignText: found text element ", updateLayersArray[layerItemIndex]);
            updateLayersArray[layerItemIndex].textColor = color;
            const updatedCanvasLayersOrdered = {
                layers: [updateLayersArray]
            }
            setCanvasLayersOrdered(updatedCanvasLayersOrdered);
            
        } else {
            //console.log("We have not selected a text element!");
        }

    }


    // Add text area to canvas
    // From clicking the toolbar bar
    const addTextToCanvas = (e, defaultText, defaultColor) => {
        
        e.preventDefault();

        const textLength = defaultText.length;
        // 28 characters seems to be the right amount for 50 pixels in height 
        // after that we need to add more height 
        const textSizeMultiplier = textLength / 28;
        const textWidth = 200 / stageScale.x;
        const textHeight = (50 * textSizeMultiplier) / stageScale.y;
        
        let posX; let posY;
        posX = stageWidth / 2 / stageScale.x;
        posY = stageHeight / 2 / stageScale.y;
        //console.og ("DRAG x= " + posX + " y= " + posY);

        // add text
        const updatedCanvasLayersOrdered = {
            layers: [canvasLayersOrdered.layers[0].concat([
                {
                    //...stageRef.current.getPointerPosition(),
                    x: posX,
                    y: posY,
                    src: null,
                    mode: "TEXT_LAYER",
                    index: canvasLayersOrdered.layers[0].length, 
                    width: textWidth,
                    height: textHeight,
                    text: defaultText,
                    fontSize: 20 / stageScale.x,
                    fontWeight: "normal",
                    fontFamily: 'TextEditorFont',
                    textAlign: 'center',
                    textColor: defaultColor,         // Default color
                    scaleX: 1,
                    flipped: false,
                    rotation: 0     // No rotation by default
                }])]
        }
        
        // DEBUG
        //console.log("DUNMP canvasLayersOrdered after COW DROPPED");
        //console.log(updatedCanvasLayersOrdered);
        setCanvasLayersOrdered(updatedCanvasLayersOrdered);
        setNbAssetsOnCanvas(nbAssetsOnCanvas+1);  // Track number of cow on canvas to generate unique id use for selection
        
        // Select the text
        setSelectedShapeId(canvasLayersOrdered.layers[0].length);
        setIsSelectedCowOnCanvas(false);
        setIsSelectedLayerOnCanvas(false);
        setIsTextBeingSelectedOnCanvas(true);
    }


    // Change textColor property of selected text 
    const updateTemplateLayerBackgroundColor = (color) => {

        // Copy the array before updating it 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        const layerItemIndex = 0;  // The first level is a blank canvas (need this for the preview)
                                   // The level above is the color of the tempalte 
        updateLayersArray[layerItemIndex].backgroundColor = color;
        updateLayersArray[layerItemIndex].mode = "TEMPLATE_COLOR_LAYER";
        const updatedCanvasLayersOrdered = {
            layers: [updateLayersArray]
        }
        //console.log(updateLayersArray);
        setCanvasLayersOrdered(updatedCanvasLayersOrdered);

    }



    // SETUP CANVAS
    // ************

    // Store the canvas state
    // This object contain all the layers (background layers + moos)
    // That are added on the canvas
    // Each item has the following properties
    //   - x
    //   - y
    //   - width
    //   - height
    //   - id
    const [canvasLayersOrdered, setCanvasLayersOrdered] = useState(
        {layers: [getAvailableBackground(0)]}
    );

    // DEBUG
    // console.log("canvasLayersOrdered DUMP...");
    // console.log(canvasLayersOrdered);

    // Canvas size
    const [stageWidth, setStageWidth] = useState(canvasLayersOrdered.layers[0][0].width);      // Default canvas width
    const [stageHeight, setStageHeight] = useState(canvasLayersOrdered.layers[0][0].height);   // Default canvas height
    const [stageScale, setStageScale] = useState({ x: 1, y: 1 });   // Default canvas scale 

    // Selecting a different background
    const changeBackgroundHandler = async ( imageSrc, imageId, imageEvent ) => {

        //console.log("changeBackgroundHandler: backgroundId=" + imageId);

        if (isAssetOnCanvas()) {
            const result = await 
            confirm("You are going to change the background but you have made change to the previous one. Are you sure you want to loose your previous creation and continue?"
            , {
                title: "Attention!",
                okText: "Let's go!",
                okButtonStyle: "success",
                cancelText: "Let me finish my previous creation",
                cancelButtonStyle: "danger"
            });
            if (result === true) {

                // If we specific an imageEvent, then we use
                // that source to fetch the asset width/height
                // This is used usually when upload your own asset
                // Since their size is not known until being render
                // on the preview pannel 
                if (imageEvent != null) {
                    const imageHeight = imageEvent.target.height;
                    const imageWidth = imageEvent.target.width;
                    //console.log("Width= " + imageWidth + " | Height= " + imageHeight );
                    editorBackgroudList[imageId][0].width = imageWidth;
                    editorBackgroudList[imageId][0].height = imageHeight;
                }
                setSelectedBackgroundId(imageId);
                resetCanvas(imageId);
            }
        } else {

            // If we specific an imageEvent, then we use
            // that source to fetch the asset width/height
            // This is used usually when upload your own asset
            // Since their size is not known until being render
            // on the preview pannel 
            if (imageEvent != null) {
                const imageHeight = imageEvent.target.height;
                const imageWidth = imageEvent.target.width;
                //console.log("Width= " + imageWidth + " | Height= " + imageHeight );
                editorBackgroudList[imageId][0].width = imageWidth;
                editorBackgroudList[imageId][0].height = imageHeight;
            }
            setSelectedBackgroundId(imageId);
            resetCanvas(imageId);
        }
    }

    // Reset canvas with a specific backgroundId
    const resetCanvas = ( imageId ) => {

        // reset the canvasLayer configuration
        const updatedCanvasLayersOrdered = {
            layers: [getAvailableBackground(imageId)]
        }
        setCanvasLayersOrdered(updatedCanvasLayersOrdered);
        setNbAssetsOnCanvas(0);
        setIsSelectedLayerOnCanvas(false);

        //console.log("changeBackgroundHandler() canvasLayersOrdered DUMP on backgroundChange event...");
        //console.log(canvasLayersOrdered);

        // Fetch the background image (which is the first layer)
        const sceneWidth  = updatedCanvasLayersOrdered.layers[0][0].width;
        const sceneHeight = updatedCanvasLayersOrdered.layers[0][0].height;
    
        // Resize the stage container accordingly 
        // console.log("resetCanvas() Need to update Stage size - x:" + sceneWidth + " y:" + sceneHeight);

        setStageWidth(sceneWidth);
        setStageHeight(sceneHeight);

        // Trigger a delayed stage refresh 
        setTriggerTimeoutStageRefresh(triggerTimeoutStageRefresh+1);
        // fitStageIntoParentContainer();
    }

    // Adjust the size of the stage to the container (useful when user reisze + at app startup)
    const fitStageIntoParentContainer = () => {
        var container = document.querySelector('#stageContainer');
        //console.log("layers OBJ", editorBackgroudList);

        const sceneWidth = editorBackgroudList[selectedBackgroundId][0].width;
        const sceneHeight = editorBackgroudList[selectedBackgroundId][0].height;

        // now we need to fit stage into parent container
        var containerWidth = container.offsetWidth;
 
        // but we also make the full scene visible
        // so we need to scale all objects on canvas
        var scale = (containerWidth / sceneWidth)*0.9;

        //console.log("Pulling sceneWidth=" + sceneWidth + " sceneHeight=" + sceneHeight);
        //console.log("Pulling containerWidth=" + containerWidth + " scale=" + scale);
        //console.log("Pulling selectedBackgroundId=" + selectedBackgroundId);
        
        setStageWidth(sceneWidth * scale);
        setStageHeight(sceneHeight * scale);
        //console.log("Updated stageWidth -> " + sceneWidth * scale);
        //console.log("Updated stageHeight -> " + sceneHeight * scale);
        

        setStageScale({ x: scale, y: scale });
        // if (containerWidth < sceneWidth) {
        //     setStageScale({ x: scale, y: scale });
        // } else {
        //     setStageScale({ x: 1, y: 1 });
        // }

    }
    


    // CONTEXTUAL MENU ACTIONS
    // ***********************

    // const [selectedShapeContextMenu, setSelectedShapeContextMenu] = useState(null);            // is the context menu on a shape selected?
    // const handleOptionSelected = option => {
    //     console.log(option);
    //     setSelectedShapeContextMenu({ selectedContextMenu: null });
    // };
    // const handleContextMenu = e => {
    //     e.evt.preventDefault(true); // NB!!!! Remember the ***TRUE***
    //     const mousePosition = e.target.getStage().getPointerPosition();
    //     console.log("mousePosition...");
    //     console.log(mousePosition);

    
    //     setSelectedShapeContextMenu({
    //       selectedContextMenu: {
    //         type: "START",
    //         position: mousePosition
    //       }
    //     });
    // };





    // UTILITY FUNCTIONS
    // *****************

    // Check if there is at least one cow on the canvas
    function isCowOnCanvas() {
        //console.log("isCowOnCanvas");
        const result = canvasLayersOrdered.layers[0];
        for (var i = 0; i < result.length; i++) {
            if (result[i].mode === "COW_LAYER") {
                //console.log("isCowOnCanvas - return TRUE");
                return true;
            }
        }
        //console.log("isCowOnCanvas - return FALSE");
        return false; 
    }

    // Check if there is at least one cow on the canvas
    function isTextOnCanvas() {
        //console.log("isCowOnCanvas");
        const result = canvasLayersOrdered.layers[0];
        for (var i = 0; i < result.length; i++) {
            if (result[i].mode === "TEXT_LAYER") {
                //console.log("isCoisTextOnCanvaswOnCanvas - return TRUE");
                return true;
            }
        }
        //console.log("isCowOnCanvas - return FALSE");
        return false; 
    }

    // Check if there is at least one cow on the canvas
    function isAssetOnCanvas() {
        return isCowOnCanvas() || isTextOnCanvas(); 
    }





    // TOGGLES ITEMS
    // ************

    // For Cards 
    // const [toggleUIInstructions, setToggleUIInstructions] = useState(true);
    const [toggleUIBackgroundSelector, setToggleUIBackgroundSelector] = useState(true);
    const [toggleUICowSelector, setToggleUICowSelector] = useState(true);





    // ASSETS MANAGEMNET
    // =================
    // Re-roll the asset specific as parameters
    // Walues are
    // - collection
    // - partner1
    // - partner2
    function reRollAssetCollection(mode) {
        console.log("RerollAsset: MODE=" + mode);
        if (mode === "collection") {
            console.log("Regenerate collection assets...");
            setAvailableCows(collectionAssetsGenerationFunction());  
        }
        if (mode.startsWith("partner")) {
            //compute partner index
            const partnerIndex = mode.substr("partner".length, 1);
            // Rebuild reslt array (updating existing reference won't trigger state refresh)
            const result = [
                allPartnerAssets[0],
                allPartnerAssets[1]];
            let newGeneration = []
            if (partnerIndex == 1) {
                console.log("Regenerate partner1 assets...");
                newGeneration = partner1AssetGenerationFunction();
            }
            if (partnerIndex == 2) {
                console.log("Regenerate partner2 assets...");
                newGeneration = partner2AssetGenerationFunction();
            } 
            result[partnerIndex-1] = newGeneration;
            console.log("partnerIndex: " + partnerIndex +  " mode: " + mode + " return", allPartnerAssets);
            console.log("new generation run: ", newGeneration);
            console.log("results: ", result);
            setAllPartnerAssets(result);
        }
    }


    // BUTTON ITEMS
    // ************

    // Export image
    // function from https://stackoverflow.com/a/15832662/512042
    function downloadURI(uri, name) {
        var link = document.createElement('a');
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const handleImageExport = () => {
        // Deselect any selected cow
        // To prevent anchor to be exported
        handleUnselectCow();

        // Timeout to wait for the unselection to complete 
        setTriggerTimeoutDownloadAssetRefresh(triggerTimeoutDownloadAssetRefresh+1);
    };

    // Delete the currently selected cow from the canvas
    const deleteSelectedAsset = () => {
       
        // Fetch selectedElement
        const selectedCowId = selectedShapeId;
        // Lookup the index value in the array
        // We don't do a simple array[index] since the index
        // value might not follow the array order once we start 
        // moving element up and down the layers 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        const layerItem = updateLayersArray.find(i => i.index === selectedCowId);
        const layerItemIndex = updateLayersArray.indexOf(layerItem);
        
        // Check that we have selected a cow and not a background element
        if (canvasLayersOrdered.layers[0][layerItemIndex].mode === "COW_LAYER" || canvasLayersOrdered.layers[0][layerItemIndex].mode === "TEXT_LAYER") {
            updateLayersArray.splice(layerItemIndex, 1);

            // Need to reprocess the array to reset the index accordingly
            // This is required if we do not delete the last element from the layer stack 
            for (var h=0; h<updateLayersArray.length; h++) {
                updateLayersArray[h].index = h;
            }

            const updatedCanvasLayersOrdered = {
                layers: [updateLayersArray]
            }

            

            setCanvasLayersOrdered(updatedCanvasLayersOrdered);

            // Deselect any selected cow
            handleUnselectCow();
        } else {
            //console.log("We have not selected a cow!");
        }
    };

    // Delete all cows from cavans
    const deleteAllCows = () => {

        // Reset the canvas without confirmation
        resetCanvas(selectedBackgroundId);

        // Deselect any selected cow
        handleUnselectCow();
    }

    // Delete the currently selected cow from the canvas
    const flipSelectedCow = () => {
    
        // Fetch selectedElement
        const selectedCowId = selectedShapeId;
        // Lookup the index value in the array
        // We don't do a simple array[index] since the index
        // value might not follow the array order once we start 
        // moving element up and down the layers 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        let layerItem = updateLayersArray.find(i => i.index === selectedCowId);
        const layerItemIndex = updateLayersArray.indexOf(layerItem);

        // Check that we have selected a cow and not a background element
        if (canvasLayersOrdered.layers[0][layerItemIndex].mode === "COW_LAYER") {
            updateLayersArray[layerItemIndex].scaleX = -(updateLayersArray[layerItemIndex].scaleX);
            updateLayersArray[layerItemIndex].flipped = !(updateLayersArray[layerItemIndex].flipped);
            
            const updatedCanvasLayersOrdered = {
                layers: [updateLayersArray]
            }
            setCanvasLayersOrdered(updatedCanvasLayersOrdered);
        } else {
            //console.log("We have not selected a cow!");
        }
    };

    // Delete the currently selected cow from the canvas
    const bringSelectedShapeToFront = () => {

        // Fetch selectedElement
        const selectedCowId = selectedShapeId;
        //console.log("selectedCowId...");
        //console.log(selectedCowId);

        // Lookup the index value in the array
        // We don't do a simple array[index] since the index
        // value might not follow the array order once we start 
        // moving element up and down the layers 
        let updateLayersArray = canvasLayersOrdered.layers[0];
        const layerItem = updateLayersArray.find(i => i.index === selectedCowId);
        const layerItemIndex = updateLayersArray.indexOf(layerItem);

        const removedLayer = updateLayersArray.splice(layerItemIndex, 1);

        //console.log("removedLayer...");
        //console.log(removedLayer);

        updateLayersArray.push(removedLayer[0]);
        // Rebuild the list of layers
        const updatedCanvasLayersOrdered = {
            layers: [updateLayersArray]
        }

        //console.log("bringSelectedShapeToFront...");
        //console.log(updatedCanvasLayersOrdered);

        setCanvasLayersOrdered(updatedCanvasLayersOrdered);

    };

    

    // Function to deselect cow
    // We are assuming we are calling this
    // Only if we know the selected item is a cow
    // If not, need to add logic to check for that
    const handleUnselectCow = () => {
        // Deselect any selected cow
        // To prevent anchor to be exported
        setSelectedShapeId(null);
        setIsSelectedCowOnCanvas(false);
        setIsSelectedLayerOnCanvas(false);
        setIsTextBeingEditedOnCanvas(false);
        setIsTextBeingSelectedOnCanvas(false);
    };

    // Add asset to canvas
    // Either from clicking on the asset on the area
    // or from dran-dropping to the canva area 
    const addAssetToCanvas = (e, assetData, ignorePointerPosition, alternativeCanvaImage = null) => {
        e.preventDefault();

        // const cowIndex = assetData.index;

        // The scale factor by which we want to scale the image
        // from the size on the pannel to the size on the canvas
        const SCALE_INDEX_IMAGE_FROM_PANNEL_TO_CANVAS = 2;

        //console.log("addAssetToCanvas with e=", e);
        let posX; let posY; let src; 
        let imageHeight; let imageWidth;
        let canvasFullHeight; let canvasFullWidth;

        // Full size of the canvas before being resized to fit the 
        // space on screen (we need this to process positionning )
        canvasFullWidth = stageWidth / stageScale.x
        canvasFullHeight = stageHeight / stageScale.y;
        
        // console.log("addAssetToCanvas - scaleX= " + stageScale.x + " | scaleY= " + stageScale.y );
        // console.log("addAssetToCanvas - canvasFullWidth= " + canvasFullWidth + " | canvasFullHeight= " + canvasFullHeight );
        if (ignorePointerPosition) {
            
            // If we set ignorePointerPosition===true, then we use
            // that e element source to fetch the asset width/height
            imageHeight = e.target.height * ( 1 / stageScale.x) * SCALE_INDEX_IMAGE_FROM_PANNEL_TO_CANVAS;
            imageWidth = e.target.width * ( 1 / stageScale.y) * SCALE_INDEX_IMAGE_FROM_PANNEL_TO_CANVAS;
            
            // Need to compute image center position manually since we clicked on the cow
            // Actually this seems to be the center of the image rather than top left
            posX = (canvasFullWidth / 2 );// - (imageHeight / 2) )  ;
            posY = (canvasFullHeight / 2 );// - (imageWidth / 2) )  ;
            src = e.target.src;
            //index = cowIndex; 

            // console.log("Width= " + imageWidth + " | Height= " + imageHeight );
            // console.log("stageWidth= " + stageWidth + " | stageHeight= " + stageHeight );
            // console.log("posX= " + posX + " | posY= " + posY );
            // console.log("scaleX= " + stageScale.x + " | scaleY= " + stageScale.y );

        } else {

            // Fetch the image center position based on pointer position 
            // register event position
            stageRef.current.setPointersPositions(e);
            imageHeight = dragUrlHeight.current * (1 / stageScale.x) * SCALE_INDEX_IMAGE_FROM_PANNEL_TO_CANVAS;
            imageWidth =dragUrlWidth.current * (1 / stageScale.y) * SCALE_INDEX_IMAGE_FROM_PANNEL_TO_CANVAS;
            posX = (stageRef.current.getPointerPosition().x) / stageScale.x;// - (imageWidth /2)) / stageScale.x;
            posY = (stageRef.current.getPointerPosition().y) / stageScale.y;// - (imageHeight /2)) / stageScale.y;
            src = dragUrl.current;
            //index = dragUrlId.current;

        }

        //console.log("addAssetToCanvas: altSource=" + alternativeCanvaImage);

        if (alternativeCanvaImage !== null) {
            src = alternativeCanvaImage;
        }
        
        // add image
        const updatedCanvasLayersOrdered = {
            layers: [canvasLayersOrdered.layers[0].concat([
                {
                    //...stageRef.current.getPointerPosition(),
                    x: posX,
                    y: posY,
                    src: src,
                    // id: dragUrlId.current,
                    mode: "COW_LAYER",
                    index: canvasLayersOrdered.layers[0].length, 
                    width: imageWidth,
                    height: imageHeight,
                    scaleX: 1,
                    scaleY: 1,
                    flipped: false,
                    rotation: 0     // No rotation by default
                }])]
        }
        
        // DEBUG
        //console.log("DUNMP canvasLayersOrdered after COW DROPPED");
        //console.log(updatedCanvasLayersOrdered);
        setCanvasLayersOrdered(updatedCanvasLayersOrdered);
        setNbAssetsOnCanvas(nbAssetsOnCanvas+1);  // Track number of cow on canvas to generate unique id use for selection

        // Select asset clicked
        setSelectedShapeId(canvasLayersOrdered.layers[0].length);
        setIsSelectedCowOnCanvas(true);
        setIsSelectedLayerOnCanvas(false);
        setIsTextBeingSelectedOnCanvas(false);
    }



    // IMAGE UPLOADS
    // *************
    
    const [uploadBackground, setUploadBackground] = useState([]);
    function onUploadBackgroundImageChange(e) {
        setUploadBackground([...e.target.files]);
    }

    useEffect(() => {
        if (uploadBackground.length <1) {
            return;
        }
        let newImagesUrls = [];
        // We currently only loop this once since we only allow one
        // Image to be uploaded at a time from the UI
        uploadBackground.forEach(image =>  {
                const src = URL.createObjectURL(image);
                //console.log("IMAGE", image);
                let width = 512;        // Random Value
                let height = 512;       // Random Value
                //ImageReact.getSize(image, (width, height));
                newImagesUrls.push(
                    [{ 
                        index: 0, mode: "BACKGROUND", category: "background_userUpload", name: "User Background",  
                        src: src, 
                        width: width, height: height, x:0, y:0
                    }]
                )
            }
        );
        setEditorBackgroudList(editorBackgroudList.concat(newImagesUrls));
        setAvailableBackground(availableBackground.concat(newImagesUrls));

    }, [uploadBackground]);

    const [uploadAsset, setUploadAsset] = useState([]);
    function onUploadAssetImageChange(e) {
        setUploadAsset([...e.target.files]);
    }

    useEffect(() => {
        if (uploadAsset.length <1) {
            return;
        }
        let newImagesUrls = [];
        // We currently only loop this once since we only allow one
        // Image to be uploaded at a time from the UI
        newImagesUrls = [];
        uploadAsset.forEach(image =>  {
            const src = URL.createObjectURL(image);
            //console.log("IMAGE", image);
            let width = 128;        // Random Value
            let height = 128;       // Random Value
            //ImageReact.getSize(image, (width, height));
            newImagesUrls.push(
                {   
                    index: 0, 
                    type: "CUSTOM_ASSET",
                    id: 'customAsset_' + availableAssets.length,
                    image_local_file_transparent: src, 
                    name: "User Asset",
                    scale: 1,               // -1 to flip the element
                    addedToCanvas: false,    // Allow to only add the cow once to the canvas
                    width: width, height: height, x:0, y:0
                }
            )
        });
        //console.log(availableAssets);
        setAvailableAssets(availableAssets.concat(newImagesUrls));
        
    }, [uploadAsset]);
    
    // Create a reference to the hidden file input element
    const hiddenUploadBackgroundFileInput = React.useRef(null);
    const hiddenUploadAssetFileInput = React.useRef(null);

    // Programatically click the hidden file input element
    // when the Button component is clicked
    const handleUploadBackgroundButtonClick = event => {
        hiddenUploadBackgroundFileInput.current.click();
    };

    // Programatically click the hidden file input element
    // when the Button component is clicked
    const handleUploadAssetButtonClick = event => {
        hiddenUploadAssetFileInput.current.click();
    };

    

























return (

    <>

    <Container fluid h-100 className="backgroundGeneratorTopContainer">

        {/* For any application level message we want to display to the user */}
        <ToastContainer type="error" position="top-center"/>

            <Row className="h-100 pt-2">
            
            {/* ASSET SELECTOR LEFT HAND SIDE */}
            <Col className="col-md-12 col-lg-4 col-xl-3">
                <Container className="">
                    <Card className="mb-2 menuContainer">
                        <Card.Header 
                                className="accordionHeader text-left"
                                onClick={() => setToggleUICowSelector(toggleUICowSelector => !toggleUICowSelector)}
                                aria-controls="collapseUICowSelector"
                                aria-expanded={toggleUICowSelector}>{props.labelsConfig.availableItems}
                                <ArrowsCollapse className="float-right"/>
                        </Card.Header>
                        <Collapse in={toggleUICowSelector}>
                            <div className="collapse" id="collapseUICowSelector">

                                <Accordion flish="true" defaultActiveKey={accordionDefaultActiveKey} flush>
         
                                        { ( allowCheckUserWallet ) && (

                                        <Card>
                                            <Card.Header className="moduleHeader">
                                            <GenericBootstrapAccordionToggle eventKey="10">{props.labelsConfig.myAssetTitlePannel}</GenericBootstrapAccordionToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="10">
                                            <Card.Body className="moduleContent">

                                            {(myCows.length >0) ? (
  
                                                <PaginatedItems 
                                                    itemsPerPage={8} 
                                                    data={myCows} 
                                                    config={props}
                                                    addAssetToCanvasFunction={addAssetToCanvas}
                                                />                                                

                                            ):(

                                                <>

                                                { (wallet.status !== 'connected') ? (

                                                    <>
                                                    <Row>
                                                        Connect your wallet to lookup the {props.labelsConfig.assetName}(s) you own.  
                                                    </Row>
                                                    <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">
                                                        <WalletConnectionButtons isMiniMode={true} />
                                                    </Row>
                                                    </>

                                                ) : (

                                                    <>                                      
                                                    <Row>
                                                        Unfortunately we can't find any {props.labelsConfig.assetName}(s) in the wallet provided...
                                                    </Row>
                                                    <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">
                                                        <Button title="Disconnect wallet" 
                                                                className="btn-success menu-icon"
                                                                onClick={() => walletDisconnect('reset')}>
                                                            <Wallet2 /> Disconnect Wallet
                                                        </Button>
                                                    </Row>
                                                    </>

                                                )}

                                                </>

                                            )}

                                            <Row className="d-flex justify-content-center align-items-center align-self-center mt-2">Wallet to lookup: </Row>
                                            <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                <div class="input-group">
                                                    <input type="text" 
                                                            class="form-control" 
                                                            placeholder="Or provide a wallet to lookup here..." 
                                                            value={ownerWalletAddress || ""}
                                                            onChange={evt => setOwnerWalletAddress(evt.target.value)}></input>
                                                </div>
                                            </Row>

                                            </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>

                                        )}

                                        <Card>
                                            <Card.Header className="moduleHeader">
                                            <GenericBootstrapAccordionToggle eventKey="11">{props.labelsConfig.allAssetTitlePannel}</GenericBootstrapAccordionToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="11">
                                            <Card.Body className="moduleContent">

                                                <PaginatedItems 
                                                    itemsPerPage={8} 
                                                    data={availableCows} 
                                                    config={props}
                                                    addAssetToCanvasFunction={addAssetToCanvas}
                                                />

                                                <Container className="text-center">
                                                    
                                                    { ((allowAssetSelection) &&

                                                        <>
                                                            <Row className="mt-2 mb-2 d-flex justify-content-center align-items-center align-self-center">
                                                                <div>{props.labelsConfig.assetSearchLabelText}</div>
                                                            </Row>
                                                            <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                                Trait search:&nbsp;<input 
                                                                type="text"
                                                                style={{width: "130px"}} 
                                                                value={searchQueryAssetCollection || ""}
                                                                onChange={evt => updateInputValueForCollectionSelector(evt)}></input><Button title="Perform Search" className="mt-2 ml-2 btn-success menu-icon" onClick={performSearchQueryAssetCollection}>
                                                                <PlusCircle/> {props.labelsConfig.assetSearchButtonText}</Button>
                                                            </Row>
                                                        </>
                                                    )}

                                                    { ((allowAssetReRollConfig.collection) &&

                                                        <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                            <Button title="Let's Roll The Dice" className="mt-2 ml-2 btn-success menu-icon" onClick={() => reRollAssetCollection("collection")}>
                                                                <Dice5/> Randomise
                                                            </Button>
                                                        </Row>
                                                    
                                                    )}

                                                </Container>

                                            </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>

                                        { ( canDisplayPartner1Panel ) && (

                                            <Card>
                                                <Card.Header className="moduleHeader">
                                                <GenericBootstrapAccordionToggle eventKey="12">{props.labelsConfig.partner1TitlePannel}</GenericBootstrapAccordionToggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey="12">
                                                <Card.Body className="moduleContent">

                                                <PaginatedItems 
                                                    itemsPerPage={8} 
                                                    data={allPartnerAssets[0]} 
                                                    config={props}
                                                    addAssetToCanvasFunction={addAssetToCanvas}
                                                />

                                                <Container className="text-center">
                                                    
                                                    { ((allowAssetSelection) &&
                                                        <>
                                                            <Row className="mt-2 mb-2 d-flex justify-content-center align-items-center align-self-center">
                                                                <div>{props.labelsConfig.partner1AssetSearchLabelText}</div>
                                                            </Row>
                                                            <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                                Trait search:&nbsp;<input 
                                                                type="text"
                                                                style={{width: "130px"}} 
                                                                value={searchQueryPartner1Collection || ""}
                                                                onChange={evt => updateInputValueForPartner1Selector(evt)}></input><Button title="Perform Search" className="mt-2 ml-2 btn-success menu-icon" onClick={performSearchQueryPartner1Collection}>
                                                                <PlusCircle/> {props.labelsConfig.partner1AssetSearchButtonText}</Button>
                                                            </Row>
                                                        </>
                                                    )}

                                                    { ((allowAssetReRollConfig.partner1) &&

                                                        <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                            {/* <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                                Want to generate a different set of assets for this partner's collection? 
                                                            </Row> */}
                                                            <Button title="Let's Roll The Dice" className="mt-2 ml-2 btn-success menu-icon" onClick={() => reRollAssetCollection("partner1")}>
                                                                <Dice5/> Randomise
                                                            </Button>
                                                        </Row>
                                                    
                                                    )}

                                                </Container>

                                                </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                        )}

                                        { ( canDisplayPartner2Panel ) && (

                                            <Card>
                                                <Card.Header className="moduleHeader">
                                                <GenericBootstrapAccordionToggle eventKey="13">{props.labelsConfig.partner2TitlePannel}</GenericBootstrapAccordionToggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey="13">
                                                <Card.Body className="moduleContent">

                                                <PaginatedItems 
                                                    itemsPerPage={8} 
                                                    data={allPartnerAssets[1]} 
                                                    config={props}
                                                    addAssetToCanvasFunction={addAssetToCanvas}
                                                />


                                                <Container className="text-center">
                                                    
                                                    { ((allowAssetSelection) &&
                                                        <>
                                                            <Row className="mt-2 mb-2 d-flex justify-content-center align-items-center align-self-center">
                                                                <div>{props.labelsConfig.partner2AssetSearchLabelText}</div>
                                                            </Row>
                                                            <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                                Trait search:&nbsp;<input 
                                                                type="text"
                                                                style={{width: "130px"}} 
                                                                value={searchQueryPartner2Collection || ""}
                                                                onChange={evt => updateInputValueForPartner2Selector(evt)}></input><Button title="Perform Search" className="mt-2 ml-2 btn-success menu-icon" onClick={performSearchQueryPartner2Collection}>
                                                                <PlusCircle/> {props.labelsConfig.partner2AssetSearchButtonText}</Button>
                                                            </Row>
                                                        </>
                                                    )}

                                                    { ((allowAssetReRollConfig.partner2) &&

                                                        <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                            {/* <Row className="d-flex justify-content-center align-items-center align-self-center">
                                                                Want to generate a different set of assets for this partner's collection? 
                                                            </Row> */}
                                                            <Button title="Let's Roll The Dice" className="mt-2 ml-2 btn-success menu-icon" onClick={() => reRollAssetCollection("partner2")}>
                                                                <Dice5/> Randomise
                                                            </Button>
                                                        </Row>
                                                    
                                                    )}

                                                </Container>

                                                </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                        )}


                                        { ( canDisplayAccessories1Panel ? (

                                                <Card>
                                                    <Card.Header className="moduleHeader d-flex justify-content-start">
                                                    <GenericBootstrapAccordionToggle eventKey="14">{props.labelsConfig.accessories1TitlePannel}</GenericBootstrapAccordionToggle>
                                                    </Card.Header>
                                                    <Accordion.Collapse eventKey="14">
                                                    <Card.Body className="moduleContent">
                                                        
                                                        <PaginatedItems 
                                                            itemsPerPage={8} 
                                                            data={availableAccessories1} 
                                                            config={props}
                                                            addAssetToCanvasFunction={addAssetToCanvas}
                                                        />
                                                    
                                                    </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>

                                        ) : (

                                            <>

                                            { ( accessories1PannelWalletRequired && (

                                                <Card>
                                                    <Card.Header className="moduleHeader d-flex justify-content-start">
                                                    <GenericBootstrapAccordionToggle eventKey="15">{props.labelsConfig.accessories1TitlePannel}</GenericBootstrapAccordionToggle>
                                                    </Card.Header>
                                                    <Accordion.Collapse eventKey="15">
                                                    <Card.Body className="moduleContent">
                                                        {(wallet.status !== 'connected') ? (
                                                            <>
                                                            <Row>{props.labelsConfig.accessories1MessageToConnectWallet}</Row>
                                                            <WalletConnectionButtons isMiniMode={true} />
                                                            </>
                                                        ): (
                                                            <>
                                                            <Row>{props.labelsConfig.accessories1MessageNoNFTFoundInWallet}</Row>
                                                            <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">
                                                                <Button title="Disconnect Wallet" 
                                                                        className="btn-success menu-icon"
                                                                        onClick={() => walletDisconnect('reset')}>
                                                                    <Wallet2 /> Disconnect Wallet
                                                                </Button>
                                                            </Row>
                                                            </>
                                                        )}
                                                    
                                                    </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>

                                            )) }

                                            </>

                                        ))}

                                        { ( canDisplayAccessories2Panel ? (

                                        <Card>
                                            <Card.Header className="moduleHeader d-flex justify-content-start">
                                            <GenericBootstrapAccordionToggle eventKey="16">{props.labelsConfig.accessories2TitlePannel}</GenericBootstrapAccordionToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="16">
                                            <Card.Body className="moduleContent">
                                                
                                                <PaginatedItems 
                                                    itemsPerPage={8} 
                                                    data={availableAccessories2} 
                                                    config={props}
                                                    addAssetToCanvasFunction={addAssetToCanvas}
                                                />
                                            
                                            </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>

                                        ) : (

                                            <>

                                            { ( accessories2PannelWalletRequired && (

                                            <Card>
                                                <Card.Header className="moduleHeader d-flex justify-content-start">
                                                <GenericBootstrapAccordionToggle eventKey="15">{props.labelsConfig.accessories2TitlePannel}</GenericBootstrapAccordionToggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey="15">
                                                <Card.Body className="moduleContent">
                                                    {(wallet.status !== 'connected') ? (
                                                        <>
                                                        <Row>{props.labelsConfig.accessories2MessageToConnectWallet}</Row>
                                                        <WalletConnectionButtons isMiniMode={true} />
                                                        </>
                                                    ): (
                                                        <>
                                                        <Row>{props.labelsConfig.accessories2MessageNoNFTFoundInWallet}</Row>
                                                        <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">
                                                            <Button title="Disconnect Wallet" 
                                                                    className="btn-success menu-icon"
                                                                    onClick={() => walletDisconnect('reset')}>
                                                                <Wallet2 /> Disconnect Wallet
                                                            </Button>
                                                        </Row>
                                                        </>
                                                    )}
                                                
                                                </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                            )) }

                                            </>

                                        ))}

                                        { props.allowAssetUploadAsAssets && (

                                        <Card>
                                            <Card.Header className="moduleHeader d-flex justify-content-start">
                                                <GenericBootstrapAccordionToggle eventKey="17">{props.labelsConfig.yourUploadedAsset}</GenericBootstrapAccordionToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="17">
                                            <Card.Body className="moduleContent">
                                                <div className="row justify-content-center">

                                                    {availableAssets.map(d => (
                                                        <>
                                                        <Col className="col">
                                                            <img
                                                                className="mt-2"
                                                                alt={d.name}
                                                                src={d.image_local_file_transparent}
                                                                height={74}
                                                                draggable={d.image_local_file_thumbnail === d.image_local_file_transparent}
                                                                onClick={(e) => {
                                                                    if (!d.addedToCanvas) {
                                                                        addAssetToCanvas(e, d, true);
                                                                    }
                                                                }}
                                                                onDragStart={(e) => {
                                                                    dragUrl.current = e.target.src;
                                                                    dragUrlId.current = d.index;
                                                                    dragUrlHeight.current = e.target.height;
                                                                    dragUrlWidth.current = e.target.width;
                                                                }} 
                                                                title={d.name}
                                                            />
                                                            { (props.displayItemLegendConfig.uploads === true) && 
                                                                <span className="row justify-content-center BGAssetLegend">{d.name}</span>
                                                            }
                                                        </Col>
                                                        </>                                           
                                                    ))}

                                                    <Container className="text-center">
                                                        <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">
                                                            Select an asset you would like to upload
                                                        </Row>
                                                        <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">
                                                                <input 
                                                                    value="" 
                                                                    id="fileUpload"
                                                                    ref={hiddenUploadAssetFileInput} 
                                                                    name="file" type="file" single="true" accept="image/*" 
                                                                    style={{ display: "none" }} 
                                                                    onChange={onUploadAssetImageChange}/>
                                                                <label htmlFor="fileUpload">
                                                                    <Button title="Upload Your Own Asset" 
                                                                            className="btn-success menu-icon"
                                                                            onClick={handleUploadAssetButtonClick}>
                                                                        <Upload /> Upload asset
                                                                    </Button>
                                                                </label>
                                                        </Row>
                                                    </Container>
                                                </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card> 
                                        
                                        )}

                                    </Accordion>

                                    

                                        
                                    {/* </Card.Text>
                                </Card.Body> */}
                            </div>
                        </Collapse>
                    </Card>
                    
                </Container>

            </Col>
            
            {/* MAIN CANVAS */}
            <Col className="col-md-12 col-lg-4 col-xl-6">
                <Container className="mt-2">
                <div className="bg-toolbar d-xl-flex justify-content-center text-center">
                    <Row className="justify-content-center text-center">
                        <Col className="d-xl-flex justify-content-start">
                            { (nbAssetsOnCanvas >0) ? (
                            <>
                                <Button title="Clear Canvas" className="mt-1 ml-2 btn-success primary-icon" onClick={deleteAllCows}>
                                <Trash /> Clear
                                </Button>
                            </>
                            ) : ( 
                            <>
                                <Button title="Clear Canvas" className="mt-1 ml-2 btn-success primary-icon" disabled>
                                <Trash /> Clear
                                </Button>
                            </>
                            )}
                            { isSelectedCowOnCanvas || isTextBeingSelectedOnCanvas ? ( 
                            <>
                                <Button title="Delete Selected Item" className="mt-1 ml-2 btn-success primary-icon" onClick={deleteSelectedAsset}>
                                <XLg /> Delete
                                </Button>
                            </>
                            ) : (
                            <>
                                <Button title="Delete Selected Item" className="mt-1 ml-2 btn-success primary-icon" disabled>
                                <XLg /> Delete
                                </Button>
                            </>
                            )}
                            { isSelectedCowOnCanvas ? (
                            <>
                                <Button title="Flip Selected Item" className="mt-1 ml-2 btn-success primary-icon" onClick={flipSelectedCow}>
                                <SymmetryVertical /> Flip
                                </Button>
                            </>
                            ) : ( 
                            <>
                                <Button title="Flip Selected Item" className="mt-1 ml-2 btn-success primary-icon" disabled>
                                <SymmetryVertical /> Flip
                                </Button>
                            </>
                            )}
                            { (isSelectedCowOnCanvas || isSelectedLayerOnCanvas || isTextBeingSelectedOnCanvas ) ? ( 
                            <>
                                <Button title="Bring Selected Shape To Front" className="mt-1 ml-2 btn-success primary-icon" onClick={bringSelectedShapeToFront}>
                                <Front /> To Front
                                </Button>
                            </>
                            ) : (
                            <>
                                <Button title="Bring Selected Shape To Front" className="mt-1 ml-2 btn-success primary-icon" disabled>
                                <Front /> To Front
                                </Button>
                            </>
                            )}
                        </Col>

                        <Col className="d-xl-flex">
                            { (isTextBeingSelectedOnCanvas) ? ( 
                            <>
                                <Button title="Edit Selected Text" className="mt-1 ml-2 btn-success tertiary-icon" onClick={editSelectedTextToCanvas}>
                                    <TextareaT /> Edit
                                </Button>
                                <Dropdown title="Change Text Color"  className="mt-1 ml-2 d-flex align-item-stretch justify-content-center">
                                    <Dropdown.Toggle variant="btn-success tertiary-icon" id="dropdown-basic">
                                        <Palette />&nbsp;
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {props.labelsConfig.paletteColors.map((option, index) => (
                                            <Dropdown.Item key={`TextColorPalette_` + index} onClick={ (e) => {updateTextColor(option.hexValue)}}><SquareFill className={option.cssClass}/> {option.text}</Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>

                                <Button title="Increase Text Font Size" 
                                        className="mt-1 ml-2 btn-success tertiary-icon" 
                                        onClick={ (e) => {updateFontSize(0.2)}}>
                                <PlusSquare />
                                </Button>
                                <Button title="Decrease Text Font Size" 
                                        className="mt-1 ml-2 btn-success tertiary-icon" 
                                        onClick={ (e) => {updateFontSize(-0.2)}}>
                                <DashSquare />
                                </Button>

                                <Button title="Align Text To The Left" 
                                        className="mt-1 ml-2 btn-success tertiary-icon" 
                                        onClick={ (e) => {alignText("left")}}>
                                <TextLeft />
                                </Button>
                                <Button title="Align Text To The Center" 
                                        className="mt-1 ml-2 btn-success tertiary-icon" 
                                        onClick={ (e) => {alignText("center")}}>
                                <TextCenter />
                                </Button>
                                <Button title="Align Text To The Right" 
                                        className="mt-1 ml-2 btn-success tertiary-icon" 
                                        onClick={ (e) => {alignText("right")}}>
                                <TextRight />
                                </Button>
                                

                            </>
                            ) : (
                            <>
                                <Button title="Add Text" 
                                        className="mt-1 ml-2 btn-success tertiary-icon" 
                                        onClick={ (e) => {addTextToCanvas(e, props.labelsConfig.defaultTextAddedToCanvas, props.labelsConfig.paletteColor1HexValue)}}>
                                <Fonts /> Add
                                </Button>
                                <Dropdown title="Change Text Color" className="mt-1 ml-2 d-flex align-item-stretch justify-content-center">
                                    <Dropdown.Toggle variant="btn-success tertiary-icon text-center" id="dropdown-basic" disabled>
                                        <Palette />&nbsp;
                                    </Dropdown.Toggle>
                                </Dropdown>

                                <Button title="Increase Text Font Size"
                                        className="mt-1 ml-2 btn-success tertiary-icon" 
                                        disabled>
                                <PlusSquare />
                                </Button>
                                <Button title="Decrease Text Font Size"
                                        className="mt-1 ml-2 btn-success tertiary-icon" 
                                        disabled>
                                <DashSquare />
                                </Button>  

                                <Button title="Align Text To The Left" 
                                        className="mt-1 ml-2 btn-success tertiary-icon" 
                                        disabled>
                                <TextLeft />
                                </Button>
                                <Button title="Align Text To The Center" 
                                        className="mt-1 ml-2 btn-success tertiary-icon" 
                                        disabled>
                                <TextCenter />
                                </Button>
                                <Button title="Align Text To The Right" 
                                        className="mt-1 ml-2 btn-success tertiary-icon" 
                                        disabled>
                                <TextRight />
                                </Button>
                                
                            </>
                            )}
                        </Col>
                    </Row>
                </div>
            </Container>

            {/* Notice when people are editing text */}
            { (isTextBeingEditedOnCanvas) && (
                <Container>
                    <div className="mt-2 d-flex justify-content-center align-items-center text-center">
                        <Row>
                            <Alert variant="warning">You are currently editing text. Press <strong>Return</strong> or <strong>Esc</strong> key to exit and save.</Alert>
                        </Row>
                    </div>
                </Container>
            ) } 

                <div 
                    onDrop={(e) => {
                        // Add cow dropped from cow selection
                        addAssetToCanvas(e, null, false)
                    }}
                    onDragOver={(e) => {
                        e.preventDefault()
                    }}
                >    

                    <Container className="" id="stageContainer">

                        <div className="d-flex justify-content-center align-items-center text-center">
                            <Stage
                                className="my-3 canvas align-items-center"
                                ref={stageRef}
                                height={stageHeight}
                                width={stageWidth}
                                style={{ border: '1px solid grey' }}
                                scaleX={stageScale.x}
                                scaleY={stageScale.y}
                                onClick={(e) => {
                                    checkDeselect();
                                }}
                            >

                                <Layer>

                                    {canvasLayersOrdered.layers[0].map((layer, i) => {

                                        //console.log("Layer = ", layer);

                                        if (i === 0) {

                                            if (layer.category === "background" || layer.category === "background_userUpload") {

                                                return <BackgroundImage
                                                    mode={"BACKGROUND"} 
                                                    mykey={"Backgroud_" + i}
                                                    image={layer} 
                                                    height={layer.height} 
                                                    width={layer.width}
                                                    rotation={layer.rotation}
                                                    x={layer.x}
                                                    y={layer.y} 
                                                    onSelect={(e) => {
                                                        checkDeselect();
                                                    }}
                                                />;

                                            } else {

                                                // Assuming we clicked on the "template"

                                                return <BackgroundImage
                                                mode={"BACKGROUND_TEMPLATE"} 
                                                mykey={"BackgroundTemplate_" + i}
                                                image={layer} 
                                                height={layer.height} 
                                                width={layer.width}
                                                rotation={layer.rotation}
                                                x={layer.x}
                                                y={layer.y} 
                                                onSelect={(e) => {
                                                    checkDeselect();
                                                }}
                                            />;

                                            }

                                        } else {

                                            if (layer.mode === "BACKGROUND_LAYER") {

                                                return <DraggableAndResizableImage 
                                                    mode={"BACKGROUND_LAYER"}
                                                    mykey={"BackgroundLayer_" + i}
                                                    image={layer}  
                                                    shapeProps={layer}
                                                    isSelected={layer.index === selectedShapeId}
                                                    onSelect={(e) => {
                                                        // DEBUG
                                                        //console.log("We selected backgroundId: " + layer.index);
                                                        // TODO: Should we select this shape if this is a background? 
                                                        setSelectedShapeId(layer.index);
                                                        setIsSelectedCowOnCanvas(false);
                                                        setIsSelectedLayerOnCanvas(true);
                                                    }}

                                                />;
                                                
                                            } else if (layer.mode === "COW_LAYER") {

                                                // expecteding "COW_LAYER"
                                                // which we can move and resize 

                                                return <DraggableAndResizableImage 
                                                    mode={"COW_LAYER"}
                                                    mykey={"AssetLayer_" + i}
                                                    image={layer}  
                                                    shapeProps={layer}
                                                    isSelected={layer.index === selectedShapeId}
                                                    onSelect={() => {
                                                        // DEBUG
                                                        //console.log("We selected cowId: " + layer.index);
                                                        //console.log("onSelect selectedShapeId=" + selectedShapeId + " layer=", layer);
                                                        setSelectedShapeId(layer.index);
                                                        setIsSelectedCowOnCanvas(true);
                                                        setIsSelectedLayerOnCanvas(false);
                                                    }}
                                                    onChange={(newAttrs) => {
                                                        // Override shape attributes after a drag/rotate (once on canvas)
                                                        // console.log("In onchange with attr=", newAttrs);
                                                        const cowData = canvasLayersOrdered.layers[0].slice();
                                                        
                                                        cowData[i].x = newAttrs.x;
                                                        cowData[i].y = newAttrs.y;                                        
                                                        cowData[i].width = newAttrs.width;                                        
                                                        cowData[i].height = newAttrs.height; 
                                                        cowData[i].addedToCanvas = true;  
                                                        cowData[i].rotation = newAttrs.rotation; 
                                                        cowData[i].scaleX = newAttrs.scaleX;  
                                                        
                                                        setCanvasLayersOrdered({
                                                            layers: [cowData]
                                                        });
                                                    }}  
                                                    // selectedShapeContextMenu={selectedShapeContextMenu}   
        
                                                />;

                                            } else {

                                                // ASSUMING TEXT_LAYER

                                                return <EditableText 

                                                    mykey={"EditableText_" + i}
                                                    textObject={layer}   
                                                    shapeProps={layer}
                                                    isSelected={layer.index === selectedShapeId && !isTextBeingEditedOnCanvas}
                                                    isEditing={layer.index === selectedShapeId && isTextBeingEditedOnCanvas}
                                                    onSelect={() => {
                                                        // DEBUG
                                                        //console.log("We selected cowId: " + layer.index);
                                                        setSelectedShapeId(layer.index);
                                                        setIsSelectedCowOnCanvas(false);
                                                        setIsSelectedLayerOnCanvas(false);
                                                        setIsTextBeingSelectedOnCanvas(true);
                                                    }}
                                                    onTextChange={(newTextValue) => {
                                                        // Override shape attribute after a drag/rotate
                                                        const textData = canvasLayersOrdered.layers[0].slice();
                                                        textData[i].text = newTextValue;                                                        
                                                        setCanvasLayersOrdered({
                                                            layers: [textData]
                                                        });
                                                    }}  
                                                    onChange={(newAttrs) => {
                                                        // Override shape attribute after a drag/rotate
                                                        const textData = canvasLayersOrdered.layers[0].slice();
                                                        
                                                        //console.log("Attribute before ", textData[i].fontSize);
                                                        
                                                        textData[i].x = newAttrs.x;
                                                        textData[i].y = newAttrs.y;                                        
                                                        textData[i].width = newAttrs.width;                                        
                                                        textData[i].height = newAttrs.height; 
                                                        textData[i].addedToCanvas = true;  
                                                        textData[i].rotation = newAttrs.rotation; 
                                                        textData[i].scaleX = newAttrs.scaleX;  
                                                        textData[i].fontSize = newAttrs.fontSize;
                                                        textData[i].text = newAttrs.text;

                                                        //console.log("Attribute after ", newAttrs.fontSize);

                                                        
                                                        setCanvasLayersOrdered({
                                                            layers: [textData]
                                                        });
                                                    }}  
                                                    // onTextClick={(newSelected) => {
                                                    //     console.log("OnTextClick with newSelected=", newSelected);
                                                    // }} 
                                                    onEditing={(isEditing) => {
                                                        //console.log("Are we editing text? " + isEditing);
                                                        setIsTextBeingEditedOnCanvas(isEditing);
                                                    }}
                                                    // onSelecting={(isSelected) => {
                                                    //     console.log("Are we selecting text? " + isSelected);
                                                    //     setIsTextBeingSelectedOnCanvas(isSelected);
                                                    // }} 
    
                                                />;

                                            }
                                        }
                                    })} 

                                </Layer>

                            </Stage>
                            
                            </div>
                    </Container>
                    
                </div>

                <Container className="mb-4">
                    <div className="bg-toolbar d-flex justify-content-center align-items-stretch text-center">
                        
                        <Row className="justify-content-center text-center">

                            <Col className="d-xl-flex justify-content-start">
                                <Button title="Useful When The Cavas Does Not Properly Fit On Your Screen" className="mt-1 ml-2 btn-success tertiary-icon" onClick={fitStageIntoParentContainer}>
                                    <Wrench /> Refresh Canvas
                                </Button>
                            </Col>

                            <Col className="d-xl-flex justify-content-end">
                                <Button title="Instructions On How To Use This Tool" className="mt-1 btn-success secondary-icon" onClick={handleInstructionsModalShow}>
                                    <Book /> Instructions
                                </Button>
                                <Button title="Download Your Creation" className="mt-1 ml-2 btn-success secondary-icon" onClick={handleImageExport}>
                                    <Download /> Download
                                </Button>
                            </Col>

                        </Row>
                    </div>
                </Container>

            </Col>
            
            {/* BACKGROUND SELECTOR RIGHT HAND SIDE  */}
            <Col className="col-md-12 col-lg-4 col-xl-3">
                <Container className="mt-3">

                    <Card className="mb-2 menuContainer">
                        <Card.Header 
                                className="accordionHeader text-left"
                                onClick={() => setToggleUIBackgroundSelector(toggleUIBackgroundSelector => !toggleUIBackgroundSelector)}
                                aria-controls="collapseUIBackgroundSelector"
                                aria-expanded={toggleUIBackgroundSelector}>{props.labelsConfig.availableBackgrounds}<ArrowsCollapse className="float-right"/></Card.Header>
                        <Collapse in={toggleUIBackgroundSelector}>

                            <div className="collapse" id="collapseUIInstructions">
                                    <Accordion flish="true" defaultActiveKey="20" flush>
                                        <Card>
                                            <Card.Header className="moduleHeader d-flex justify-content-start">
                                            <GenericBootstrapAccordionToggle eventKey="20">{props.labelsConfig.officialBackgrounds}</GenericBootstrapAccordionToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="20">
                                            <Card.Body className="moduleContent">
                                                
                                                <div className="row">        
                                                    {editorBackgroudList.map((image, i) => {

                                                        return (
                                                        <>
                                                        {(image[0].category === "background") && (
                                                        <Col className="col">
                                                        
                                                                <div className="col">
                                                                    <img
                                                                        alt={image[0].name}
                                                                        title={image[0].name}
                                                                        className=""
                                                                        src={image[0].src}
                                                                        width={200}
                                                                        draggable="false"
                                                                        onClick={() => {
                                                                            changeBackgroundHandler(image[0].src, i)
                                                                        }}
                                                                    />
                                                                    { (props.displayItemLegendConfig.background === true) && 
                                                                        <span className="row justify-content-center BGAssetLegend">{image[0].name}</span>
                                                                    }
                                                                </div>
                                                        </Col>
                                                        )}
                                                        
                                                        </>  
                                                        )
                                                    })}
                                                </div>
                                            
                                            </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>

                                        <Card>
                                            <Card.Header className="moduleHeader d-flex justify-content-start">
                                            <GenericBootstrapAccordionToggle eventKey="21">{props.labelsConfig.templateBackgrounds}</GenericBootstrapAccordionToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="21">
                                            <Card.Body className="moduleContent">

                                                <div className="row justify-content-center mb-2">

                                                    <Dropdown title="Change Template Color" className="mt-1 ml-2">
                                                        <Dropdown.Toggle variant="btn-success tertiary-icon" id="dropdown-basic">
                                                            Template Color
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>

                                                        
                                                            {props.labelsConfig.templateColors.map((option, index) => (
                                                                <Dropdown.Item key={`TemplateColorPalette_` + index} onClick={ (e) => {updateTemplateLayerBackgroundColor(option.hexValue, 'cardTextTitle')}}><SquareFill className={option.cssClass}/> {option.text}</Dropdown.Item>
                                                            ))}

                                                            { props.labelsConfig.templateColor1Text && (
                                                            <Dropdown.Item onClick={ (e) => {updateTemplateLayerBackgroundColor(props.labelsConfig.templateColor1HexValue)}}><SquareFill className="templateColor-one"/> {props.labelsConfig.templateColor1Text}</Dropdown.Item>
                                                            ) }
                                                            { props.labelsConfig.templateColor2Text && (
                                                            <Dropdown.Item onClick={ (e) => {updateTemplateLayerBackgroundColor(props.labelsConfig.templateColor2HexValue)}}><SquareFill className="templateColor-two" /> {props.labelsConfig.templateColor2Text}</Dropdown.Item>
                                                            ) }
                                                            { props.labelsConfig.templateColor3Text && (
                                                            <Dropdown.Item onClick={ (e) => {updateTemplateLayerBackgroundColor(props.labelsConfig.templateColor3HexValue)}}><SquareFill className="templateColor-three" /> {props.labelsConfig.templateColor3Text}</Dropdown.Item>
                                                            ) }
                                                            { props.labelsConfig.templateColor4Text && (
                                                            <Dropdown.Item onClick={ (e) => {updateTemplateLayerBackgroundColor(props.labelsConfig.templateColor4HexValue)}}><SquareFill className="templateColor-four" /> {props.labelsConfig.templateColor4Text}</Dropdown.Item>
                                                            ) }
                                                            { props.labelsConfig.templateColor5Text && (
                                                            <Dropdown.Item onClick={ (e) => {updateTemplateLayerBackgroundColor(props.labelsConfig.templateColor5HexValue)}}><SquareFill className="templateColor-five" /> {props.labelsConfig.templateColor5Text}</Dropdown.Item>
                                                            ) }
                                                            { props.labelsConfig.templateColor6Text && (
                                                            <Dropdown.Item onClick={ (e) => {updateTemplateLayerBackgroundColor(props.labelsConfig.templateColor6HexValue)}}><SquareFill className="templateColor-six" /> {props.labelsConfig.templateColor6Text}</Dropdown.Item>
                                                            ) }
                                                            { props.labelsConfig.templateColor7Text && (
                                                            <Dropdown.Item onClick={ (e) => {updateTemplateLayerBackgroundColor(props.labelsConfig.templateColor7HexValue)}}><SquareFill className="templateColor-seven" /> {props.labelsConfig.templateColor7Text}</Dropdown.Item>
                                                            ) }
                                                            { props.labelsConfig.templateColor8Text && (
                                                            <Dropdown.Item onClick={ (e) => {updateTemplateLayerBackgroundColor(props.labelsConfig.templateColor8HexValue)}}><SquareFill className="templateColor-eight" /> {props.labelsConfig.templateColor8Text}</Dropdown.Item>
                                                            ) }
                                                        </Dropdown.Menu>
                                                    </Dropdown>

                                                </div>
                                                
                                                <div className="row">        
                                                    {editorBackgroudList.map((image, i) => {

                                                        return (
                                                        <>
                                                        {(image[0].category === "template") && (
                                                        <Col className="col">
                                                                <div className="col">
                                                                    <img
                                                                        alt={image[0].name}
                                                                        title={image[0].name}
                                                                        className="border border-dark"
                                                                        src={image[0].src}
                                                                        height={80}
                                                                        draggable="false"
                                                                        onClick={() => {
                                                                            changeBackgroundHandler(image[0].src, i)
                                                                        }}
                                                                    />
                                                                    { (props.displayItemLegendConfig.template === true) && 
                                                                        <span className="row justify-content-center BGAssetLegend">{image[0].name}</span>
                                                                    }
                                                                </div>
                                                        </Col>
                                                        )}
                                                        </>  
                                                        )
                                                    })}
                                                </div>
                                            
                                            </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>

                                        { props.allowAssetUploadAsBackground && ( 

                                        <Card>
                                            <Card.Header className="moduleHeader d-flex justify-content-start">
                                                <GenericBootstrapAccordionToggle eventKey="22">{props.labelsConfig.yourUploadedBackgrounds}</GenericBootstrapAccordionToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="22">
                                            <Card.Body className="moduleContent">
                                                <div className="row justify-content-center">
       
                                                    {editorBackgroudList.map((image, i) => {

                                                        return (
                                                        <>
                                                        <Col className="d-flex justify-content-center">
                                                        {(image[0].category === "background_userUpload") && (
   
                                                                <div className="justify-content-center ">
                                                                    <img
                                                                        alt={image[0].name}
                                                                        title={image[0].name}
                                                                        className="m-1"
                                                                        src={image[0].src}
                                                                        height={80}
                                                                        draggable="false"
                                                                        onClick={(e) => {
                                                                            //console.log(e);
                                                                            changeBackgroundHandler(image[0].src, i, e)
                                                                        }}
                                                                    />
                                                                    { (props.displayItemLegendConfig.uploads === true) && 
                                                                        <span className="row justify-content-center BGAssetLegend">{image[0].name}</span>
                                                                    }
                                                                </div>
                                                        )}
                                                        </Col>
                                                        </>  
                                                        )
                                                    })}

                                                    <Container className="text-center">
                                                        <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">
                                                            Select a background you would like to upload
                                                        </Row>
                                                        <Row className="mt-2 d-flex justify-content-center align-items-center align-self-center">
                                                                <input 
                                                                    value="" 
                                                                    id="fileUpload"
                                                                    ref={hiddenUploadBackgroundFileInput}
                                                                    name="file" type="file" single="true" accept="image/*" 
                                                                    style={{ display: "none" }} 
                                                                    onChange={onUploadBackgroundImageChange}/>
                                                                <label htmlFor="fileUpload">
                                                                    <Button title="Upload Your Own Background" 
                                                                            className="btn-success menu-icon"
                                                                            onClick={handleUploadBackgroundButtonClick}>
                                                                        <Upload /> Upload background
                                                                    </Button>
                                                                </label>
                                                        </Row>
                                                    </Container>
                                                </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>   
                                        
                                        )}

                                    </Accordion>

                            </div>

                            
                        </Collapse>
                    </Card>

                </Container>
            </Col>

            {/* RIGHT CLICK MENU */}
            {/* <div id="menu">
                <div>
                    <button id="delete-button">Delete</button>
                </div>
            </div> */}

        </Row>

        {/* FOR VIDEO RECORDING PURPOSES 
        </Container>
        <br/><br/><br/>
        <Container fluid>

            <div className="row">
                {availableCows.map(d => (
                    <>
                    <div className="">
                        <img
                            className="my-1 px-5"
                            alt={d.name}
                            src={d.image_local_file_transparent}
                            height={178}
                            draggable={!d.addedToCanvas}
                            onClick={(e) => {
                                addAssetToCanvas(e, d.index, true);
                            }}
                            onClick={(e) => {
                                if (!d.addedToCanvas) {
                                    addAssetToCanvas(e, d.index, true);
                                }
                            }}
                            onDragStart={(e) => {
                                dragUrl.current = e.target.src;
                                dragUrlId.current = d.index;
                            }} 
                            title={d.name}
                        />
                    </div>
                    </>
                    
                ))}
            </div>
            <br/><br/><br/>
            <Container className="text-center">
                <Row className="d-flex justify-content-center align-items-center align-self-center">
                    { (props.isCowOwner === false) && (
                        <Button title="Give me different cows!" className="mt-2 ml-2 btn-primary primary-icon" onClick={generateAvailableAsset}>
                            <Dice5/> Re-roll 
                        </Button>
                    )}
                </Row>
        </Container> */}
    </Container> 

    {/* INSTRUCTIONS PAGE MODAL  */}
    <Modal show={instructionsModalShow} onHide={handleInstructionsModalClose}>
        <Modal.Header>
        <Modal.Title>Instructions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="text-start">
                <p>Welcome to the {props.labelsConfig.instructionsTitle}</p>
                <ul>
                    <li>Tap any {props.labelsConfig.assetName} to bring them to the canvas!</li>
                    <li>Search for {props.labelsConfig.assetName} by number or by attributes/properties</li>
                    <li>Rotate, resize and horizontal flip any {props.labelsConfig.assetName}!</li>
                    <li>Add, edit, rotate and reize text</li>
                    <li>Change backgrounds with a click or tap!</li> 
                    <li>Upload your own backgrounds or assets</li> 
                    {/* <li>Some preset backgrounds have layers</li> */}
                    <li>When finished, click “Download”. Save and share!</li>
                </ul>
            </div>
        </Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={handleInstructionsModalClose}>
            {props.labelsConfig.okButton}
        </Button>
        {/* <Button variant="primary" onClick={handleClose}>
            Save Changes
        </Button> */}
        </Modal.Footer>
    </Modal>
    
</>

)

}

export default BackgroundGenerator;